// ARCHIVO: src/pages/Ventas.jsx
// DESCRIPCION: Sistema POS FacilVirtual - Punto de Venta Profesional

import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { 
  ShoppingCart, Search, Plus, Minus, Trash2, 
  CreditCard, DollarSign, X, Eye, 
  Edit, Percent, Receipt, ShoppingBag,
  User, Phone, MapPin, Calendar, Camera, Info
} from 'lucide-react';
import { getApiBaseUrl, getComercioId } from '../config/comercio';
import { usePopup } from '../hooks/usePopup';
// Hook removido - token manejado centralmente
import Popup from '../components/Popup';

const Ventas = () => {
  // Hook para popups
  const { toast, showSuccess, showError, showConfirm, handleConfirm, handleCancel, hideToast } = usePopup();
  
  // Hook para seguridad del token
  // Funciones de token removidas - manejadas centralmente
  
  // Estados principales
  const [productos, setProductos] = useState([]);
  const [carrito, setCarrito] = useState([]);
  const [codigoBarras, setCodigoBarras] = useState('');
  const [cantidad, setCantidad] = useState(1);
  const [loading, setLoading] = useState(false);
  
  // Estado para configuración del comercio
  const [configComercio, setConfigComercio] = useState({
    id: null,
    fantasia: '',
    empresa: '',
    direccion: '',
    ciudad: '',
    codpostal: '',
    whatsapp: '',
    condicion_iva: '',
    cuit: '',
    iibb: '',
    logo_path: '',
    porcentaje_iva: 21.00,
    numero_ticket_inicio: 1,
    pie_ticket: '',
    impresora_tickets: 'termica_58mm',
    margen_izquierdo: 10,
    margen_derecho: 10,
    margen_superior: 10,
    margen_inferior: 10,
    orientacion_papel: 'portrait',
    calidad_impresion: 'normal'
  });
  
  // Estados para modales
  const [mostrarModalPago, setMostrarModalPago] = useState(false);
  const [mostrarModalDescuento, setMostrarModalDescuento] = useState(false);
  
  // Estados para pagos parciales
  const [pagosParciales, setPagosParciales] = useState([]);
  const [metodoPagoActual, setMetodoPagoActual] = useState('efectivo');
  const [montoPagoActual, setMontoPagoActual] = useState('');
  const [referenciaPago, setReferenciaPago] = useState('');
  const [observacionesPago, setObservacionesPago] = useState('');
  const [totalPagosParciales, setTotalPagosParciales] = useState(0);
  const [saldoPendiente, setSaldoPendiente] = useState(0);
  
  // Función para agregar pago parcial
  const agregarPagoParcial = () => {
    const monto = parseFloat(montoPagoActual);
    if (monto <= 0) {
      showError('El monto debe ser mayor a 0');
      return;
    }
    
    if (monto > saldoPendiente) {
      showError('El monto excede el saldo pendiente');
      return;
    }
    
    const nuevoPago = {
      id: Date.now(),
      metodo_pago: metodoPagoActual,
      monto: monto,
      referencia: referenciaPago,
      observaciones: observacionesPago,
      fecha: new Date().toLocaleString()
    };
    
    setPagosParciales(prev => [...prev, nuevoPago]);
    setMontoPagoActual('');
    setReferenciaPago('');
    setObservacionesPago('');
    
    // Recalcular totales
    const nuevoTotal = totalPagosParciales + monto;
    setTotalPagosParciales(nuevoTotal);
    setSaldoPendiente(total - nuevoTotal);
    
    showSuccess(`Pago de $${monto.toFixed(2)} agregado`);
  };
  
  // Función para eliminar pago parcial
  const eliminarPagoParcial = (id) => {
    const pago = pagosParciales.find(p => p.id === id);
    if (pago) {
      setPagosParciales(prev => prev.filter(p => p.id !== id));
      
      // Recalcular totales
      const nuevoTotal = totalPagosParciales - pago.monto;
      setTotalPagosParciales(nuevoTotal);
      setSaldoPendiente(total - nuevoTotal);
      
      showSuccess('Pago eliminado');
    }
  };
  
  // Función para limpiar pagos parciales
  const limpiarPagosParciales = () => {
    setPagosParciales([]);
    setTotalPagosParciales(0);
    setSaldoPendiente(total);
    setMontoPagoActual('');
    setReferenciaPago('');
    setObservacionesPago('');
  };
  
  // Función para mostrar modal de descuento - VERSIÓN DIRECTA
  const mostrarModalDescuentoDirecto = () => {
    console.log('🚨 MOSTRANDO MODAL DIRECTO 🚨');
    const modal = document.createElement('div');
    modal.id = 'modal-descuento-directo';
    modal.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      background-color: rgba(0, 0, 0, 0.8) !important;
      z-index: 999999999 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    `;
    
    modal.innerHTML = `
      <div style="
        background-color: white !important;
        width: 90% !important;
        max-width: 500px !important;
        padding: 2rem !important;
        border-radius: 8px !important;
        text-align: center !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
      ">
        <h2 style="margin-bottom: 1.5rem; color: #333;">💰 Aplicar Descuento</h2>
        
        <div style="margin-bottom: 1.5rem;">
          <label style="display: block; margin-bottom: 0.5rem; font-weight: bold;">
            Tipo de descuento:
          </label>
          <div style="display: flex; gap: 1rem; justify-content: center;">
            <label style="display: flex; align-items: center; gap: 0.5rem;">
              <input type="radio" name="tipoDescuento" value="importe" checked>
              <span>Importe fijo ($)</span>
            </label>
            <label style="display: flex; align-items: center; gap: 0.5rem;">
              <input type="radio" name="tipoDescuento" value="porcentaje">
              <span>Porcentaje (%)</span>
            </label>
          </div>
        </div>

        <div style="margin-bottom: 1.5rem;">
          <label style="display: block; margin-bottom: 0.5rem; font-weight: bold;">
            Valor del descuento:
          </label>
          <input 
            type="number" 
            id="valor-descuento" 
            placeholder="0.00"
            style="
              padding: 0.75rem;
              border: 2px solid #ddd;
              border-radius: 4px;
              font-size: 1.1rem;
              text-align: center;
              width: 200px;
            "
          />
        </div>

        <div style="display: flex; gap: 1rem; justify-content: center;">
          <button 
            id="cancelar-descuento"
            style="
              padding: 0.75rem 1.5rem;
              background-color: #666;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            "
          >
            Cancelar
          </button>
          <button 
            id="aplicar-descuento"
            style="
              padding: 0.75rem 1.5rem;
              background-color: #28a745;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            "
          >
            Aplicar
          </button>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // Event listeners
    document.getElementById('cancelar-descuento').onclick = () => {
      document.body.removeChild(modal);
    };
    
    document.getElementById('aplicar-descuento').onclick = () => {
      const valor = document.getElementById('valor-descuento').value;
      const tipo = document.querySelector('input[name="tipoDescuento"]:checked').value;
      
      if (valor && parseFloat(valor) > 0) {
        console.log('Aplicando descuento:', { tipo, valor });
        
        // Calcular el descuento
        let descuentoCalculado = 0;
        if (tipo === 'importe') {
          descuentoCalculado = parseFloat(valor);
        } else if (tipo === 'porcentaje') {
          const subtotal = carrito.reduce((sum, item) => sum + (item.precio_unitario * item.cantidad), 0);
          descuentoCalculado = (subtotal * parseFloat(valor)) / 100;
        }
        
        // Actualizar el descuento total (no por item, sino total de la venta)
        setDescuentoTotal(descuentoCalculado);
        
        console.log('Descuento aplicado:', descuentoCalculado);
        document.body.removeChild(modal);
      } else {
        alert('Por favor ingrese un valor válido');
      }
    };
  };
  
  // Función para mostrar modal de recargo - VERSIÓN DIRECTA
  const mostrarModalRecargoDirecto = () => {
    console.log('🚨 MOSTRANDO MODAL RECARGO DIRECTO 🚨');
    const modal = document.createElement('div');
    modal.id = 'modal-recargo-directo';
    modal.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      background-color: rgba(0, 0, 0, 0.8) !important;
      z-index: 999999999 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    `;
    
    modal.innerHTML = `
      <div style="
        background-color: white !important;
        width: 90% !important;
        max-width: 500px !important;
        padding: 2rem !important;
        border-radius: 8px !important;
        text-align: center !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
      ">
        <h2 style="margin-bottom: 1.5rem; color: #333;">💰 Aplicar Recargo</h2>
        
        <div style="margin-bottom: 1.5rem;">
          <label style="display: block; margin-bottom: 0.5rem; font-weight: bold;">
            Tipo de recargo:
          </label>
          <div style="display: flex; gap: 1rem; justify-content: center;">
            <label style="display: flex; align-items: center; gap: 0.5rem;">
              <input type="radio" name="tipoRecargo" value="importe" checked>
              <span>Importe fijo ($)</span>
            </label>
            <label style="display: flex; align-items: center; gap: 0.5rem;">
              <input type="radio" name="tipoRecargo" value="porcentaje">
              <span>Porcentaje (%)</span>
            </label>
          </div>
        </div>

        <div style="margin-bottom: 1.5rem;">
          <label style="display: block; margin-bottom: 0.5rem; font-weight: bold;">
            Valor del recargo:
          </label>
          <input 
            type="number" 
            id="valor-recargo" 
            placeholder="0.00"
            style="
              padding: 0.75rem;
              border: 2px solid #ddd;
              border-radius: 4px;
              font-size: 1.1rem;
              text-align: center;
              width: 200px;
            "
          />
        </div>

        <div style="display: flex; gap: 1rem; justify-content: center;">
          <button 
            id="cancelar-recargo"
            style="
              padding: 0.75rem 1.5rem;
              background-color: #666;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            "
          >
            Cancelar
          </button>
          <button 
            id="aplicar-recargo"
            style="
              padding: 0.75rem 1.5rem;
              background-color: #dc2626;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            "
          >
            Aplicar
          </button>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // Event listeners
    document.getElementById('cancelar-recargo').onclick = () => {
      document.body.removeChild(modal);
    };
    
    document.getElementById('aplicar-recargo').onclick = () => {
      const valor = document.getElementById('valor-recargo').value;
      const tipo = document.querySelector('input[name="tipoRecargo"]:checked').value;
      
      if (valor && parseFloat(valor) > 0) {
        console.log('Aplicando recargo:', { tipo, valor });
        
        // Calcular el recargo
        let recargoCalculado = 0;
        if (tipo === 'importe') {
          recargoCalculado = parseFloat(valor);
        } else if (tipo === 'porcentaje') {
          const subtotal = carrito.reduce((sum, item) => sum + (item.precio_unitario * item.cantidad), 0);
          recargoCalculado = (subtotal * parseFloat(valor)) / 100;
        }
        
        // Actualizar el recargo total
        setRecargoTotal(recargoCalculado);
        
        console.log('Recargo aplicado:', recargoCalculado);
        document.body.removeChild(modal);
      } else {
        alert('Por favor ingrese un valor válido');
      }
    };
  };
  
  const [mostrarModalCantidad, setMostrarModalCantidad] = useState(false);
  const [mostrarModalRecargo, setMostrarModalRecargo] = useState(false);
  
  // DEBUG: Log del estado del modal
  console.log('🔍 [DEBUG] Estado mostrarModalDescuento:', mostrarModalDescuento);
  
  // Estados para descuentos y recargos
  const [tipoDescuento, setTipoDescuento] = useState('importe'); // 'importe' o 'porcentaje'
  const [tipoRecargo, setTipoRecargo] = useState('importe'); // 'importe' o 'porcentaje'
  const [valorDescuento, setValorDescuento] = useState('');
  const [valorRecargo, setValorRecargo] = useState('');
  
  // Estados para descuentos y recargos TOTALES de la venta (no por producto)
  const [descuentoTotal, setDescuentoTotal] = useState(0); // Descuento total de la venta
  const [recargoTotal, setRecargoTotal] = useState(0); // Recargo total de la venta
  const [tipoDescuentoTotal, setTipoDescuentoTotal] = useState('importe'); // Tipo del descuento total
  const [tipoRecargoTotal, setTipoRecargoTotal] = useState('importe'); // Tipo del recargo total
  
  // Estado para el popup informativo
  const [mostrarPopupInfo, setMostrarPopupInfo] = useState(false);
  
  

  
  // Estados para pago
  const [montoRecibido, setMontoRecibido] = useState(0);
  const [cambio, setCambio] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  
  // Estados para comprobante
  const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-AR'));
  const [tipoComprobante, setTipoComprobante] = useState('Ticket Fiscal');
  const [numeroComprobante, setNumeroComprobante] = useState('');
  const [observaciones, setObservaciones] = useState('');
  
  // Estados para sistema de tickets y cierre de venta
  const [numeroTicket, setNumeroTicket] = useState(1);
  const [mostrarComprobante, setMostrarComprobante] = useState(false);
  const [ventaCompletada, setVentaCompletada] = useState(null);
  const [procesandoVenta, setProcesandoVenta] = useState(false);
  
        // Estados para scanner
    const [showCamera, setShowCamera] = useState(false);
    const [scanning, setScanning] = useState(false);
    const [error, setError] = useState('');
    const [ultimoCodigoProcesado, setUltimoCodigoProcesado] = useState('');
    const [tiempoUltimaLectura, setTiempoUltimaLectura] = useState(0);
    const [procesandoCodigo, setProcesandoCodigo] = useState(false);
    const [modoBN, setModoBN] = useState(true); // Modo blanco y negro activado por defecto
    
    // Estados para edición en línea
    const [editandoCantidad, setEditandoCantidad] = useState(null);
    const [editandoPrecio, setEditandoPrecio] = useState(null);
    const [valorTemporal, setValorTemporal] = useState('');
  
  // Referencias
  const inputCodigoRef = useRef(null);
  const videoRef = useRef(null);
  const scannerRef = useRef(null);

  // Función para reproducir beep de confirmación
  const reproducirBeep = () => {
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.setValueAtTime(800, audioContext.currentTime); // Frecuencia del beep
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(0.5, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);
    } catch (error) {
      console.log('No se pudo reproducir el beep:', error);
    }
  };

  // Función para obtener token de forma segura (App.jsx ya maneja el encapsulado)
  const obtenerTokenSeguro = () => {
    // Priorizar sessionStorage, luego localStorage
    return sessionStorage.getItem('comercio_token_secure') || 
           localStorage.getItem('comercio_token') || 
           localStorage.getItem('token');
  };


  // Cargar productos y configuración al montar
  useEffect(() => {
    // Obtener token de forma segura (App.jsx ya maneja el encapsulado)
    const token = obtenerTokenSeguro();
    
    if (token) {
      console.log('✅ [VENTAS] Token obtenido correctamente');
      // Esperar un momento para que el token se inicialice
      setTimeout(() => {
        cargarConfigComercio();
        cargarProductos();
        if (inputCodigoRef.current) {
          inputCodigoRef.current.focus();
        }
      }, 100);
    } else {
      console.error('❌ [VENTAS] No se encontró token de comercio');
      alert('Error: No se encontró token de comercio. Por favor, acceda desde el panel de administración.');
    }
  }, []);

  // Cargar número de ticket desde localStorage o configuración
  useEffect(() => {
    // Solo ejecutar cuando configComercio esté cargado
    if (!configComercio.id) return;
    
    const numeroInicio = configComercio.numero_ticket_inicio || 1;
    actualizarNumeroTicket(numeroInicio);
  }, [configComercio.id, configComercio.numero_ticket_inicio]);

  // Limpiar cámara al desmontar
  useEffect(() => {
    return () => {
      if (scannerRef.current) {
        scannerRef.current.reset();
      }
      if (videoRef.current?.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, []);


  // Debug para popup de información
  useEffect(() => {
    console.log('🔍 [POPUP_DEBUG] Estado mostrarPopupInfo cambió:', mostrarPopupInfo);
    if (mostrarPopupInfo) {
      console.log('🔍 [POPUP_DEBUG] Popup debería estar visible ahora');
    }
  }, [mostrarPopupInfo]);




  // Cargar configuración del comercio
  const cargarConfigComercio = async () => {
    try {
      const token = obtenerTokenSeguro();
      if (!token) {
        console.error('No se encontró token del comercio');
        return;
      }
      
      const response = await fetch(`https://www.sinfilas.com.ar/sf3/ventas/api/comercios_perfil_cargar.php?token=${token}`);
      const data = await response.json();
      
      if (data.success) {
        const numeroInicio = data.data.numero_ticket_inicio || 1;
        
        setConfigComercio({
          id: data.data.id,
          fantasia: data.data.fantasia || '',
          empresa: data.data.empresa || '',
          direccion: data.data.direccion || '',
          ciudad: data.data.ciudad || '',
          codpostal: data.data.codpostal || '',
          whatsapp: data.data.whatsapp || '',
          condicion_iva: data.data.condicion_iva || '',
          cuit: data.data.cuit || '',
          iibb: data.data.iibb || '',
          logo_path: data.data.logo_path || '',
          porcentaje_iva: data.data.porcentaje_iva || 21.00,
          numero_ticket_inicio: numeroInicio,
          pie_ticket: data.data.pie_ticket || '',
          impresora_tickets: data.data.impresora_tickets || 'termica_58mm',
          margen_izquierdo: data.data.margen_izquierdo || 10,
          margen_derecho: data.data.margen_derecho || 10,
          margen_superior: data.data.margen_superior || 10,
          margen_inferior: data.data.margen_inferior || 10,
          orientacion_papel: data.data.orientacion_papel || 'portrait',
          calidad_impresion: data.data.calidad_impresion || 'normal'
        });
        
        // Actualizar número de ticket consultando la API
        await actualizarNumeroTicketDesdeAPI();
        console.log('✅ Configuración del comercio cargada:', data.data.fantasia);
      } else {
        console.error('Error al cargar configuración del comercio:', data.message);
      }
    } catch (error) {
      console.error('Error al cargar configuración del comercio:', error);
    }
  };

  // Actualizar número de ticket consultando la API
  const actualizarNumeroTicketDesdeAPI = async () => {
    try {
      const token = obtenerTokenSeguro();
      if (!token) {
        console.error('No se encontró token del comercio');
        return;
      }
      
      const response = await fetch(`https://www.sinfilas.com.ar/sf3/ventas/api/obtener_ultimo_ticket.php?token=${token}`);
      const data = await response.json();
      
      if (data.success) {
        const proximoNumero = data.data.proximo_numero || 1;
        setNumeroTicket(proximoNumero);
        console.log('🎫 Número de ticket actualizado desde API:', proximoNumero);
        console.log('📊 Último número usado:', data.data.ultimo_numero_usado);
        console.log('📊 Próximo número:', data.data.proximo_numero);
        console.log('📊 Próximo ticket:', data.data.proximo_ticket);
      } else {
        console.error('Error al obtener último ticket:', data.error);
        setNumeroTicket(1);
      }
    } catch (error) {
      console.error('❌ Error al consultar API de último ticket:', error);
      setNumeroTicket(1);
    }
  };

  // Actualizar número de ticket basado en la configuración (función legacy)
  const actualizarNumeroTicket = (numeroInicio) => {
    try {
      const ventasExistentes = JSON.parse(localStorage.getItem('ventas_sinfilas') || '[]');
      
      // SIEMPRE usar el número de inicio del perfil del comercio
      // Esto asegura que se respete la configuración del comercio
      setNumeroTicket(numeroInicio);
      console.log('🎫 Usando número de inicio del perfil del comercio:', numeroInicio);
      
      // Log para debugging
      if (ventasExistentes.length > 0) {
        const ultimoTicketUsado = Math.max(...ventasExistentes.map(v => v.numeroTicket || 0));
        console.log('📊 Ventas existentes en localStorage:', ventasExistentes.length, '- Último ticket usado:', ultimoTicketUsado);
      }
      
    } catch (error) {
      console.error('❌ Error al actualizar número de ticket:', error);
      setNumeroTicket(numeroInicio);
    }
  };

  // Cargar productos del comercio
  const cargarProductos = async () => {
    try {
      setLoading(true);
      const token = obtenerTokenSeguro();
      console.log('🔍 [PRODUCTOS] Token obtenido de forma segura');
      
      if (!token) {
        showError('No se encontró token del comercio', 'Error de Autenticación');
        return;
      }
      
      const url = `${getApiBaseUrl()}/productos_comercio_listar.php?token=${token}`;
      console.log('🔍 [PRODUCTOS] URL de petición:', url);
      
      const response = await fetch(url);
      console.log('🔍 [PRODUCTOS] Respuesta del servidor:', response.status, response.statusText);
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status} - ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('🔍 [PRODUCTOS] Datos recibidos:', data);
      
      if (data.success) {
        const productosValidos = data.productos
          .filter(p => p.activo && p.stock_actual > 0)
          .map(p => ({
            ...p,
            precio_venta: parseFloat(p.precio_venta) || 0,
            stock_actual: parseInt(p.stock_actual) || 0
          }));
        
        setProductos(productosValidos);
      } else {
        setProductos([]);
      }
    } catch (error) {
      console.error('Error al cargar productos:', error);
      setProductos([]);
    } finally {
      setLoading(false);
    }
  };

  // Buscar y agregar producto
  const buscarYAgregarProducto = async (codigo, cantidadManual = null) => {
    try {
      // Limpiar y validar el código
      const codigoLimpio = codigo.toString().trim();
      
      if (!codigoLimpio) {
        showError('Por favor ingresa un código de barras válido', 'Código Inválido');
        return;
      }
      
      console.log('🔍 Buscando producto con código:', codigoLimpio);
      console.log('🔗 URL de búsqueda:', `${getApiBaseUrl()}/productos_comercio_buscar.php`);
      
      const token = obtenerTokenSeguro();
      if (!token) {
        showError('No se encontró token del comercio', 'Error de Autenticación');
        return;
      }
      
      const response = await fetch(`${getApiBaseUrl()}/productos_comercio_buscar.php?token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ codigo_personalizado: codigoLimpio })
      });
      
      console.log('📡 Respuesta del servidor:', response.status, response.statusText);
      
      const data = await response.json();
      console.log('📊 Datos recibidos:', data);
      
      if (data.success && data.producto) {
        const producto = data.producto;
        console.log('✅ Producto encontrado:', producto);
        console.log('🔍 Verificando disponibilidad:');
        console.log('  - Activo:', producto.activo);
        console.log('  - Stock actual:', producto.stock_actual);
        console.log('  - Condición activo:', producto.activo === 1 || producto.activo === true);
        console.log('  - Condición stock:', producto.stock_actual > 0);
        
        if ((producto.activo === 1 || producto.activo === true) && producto.stock_actual > 0) {
          console.log('✅ Producto disponible, agregando al carrito...');
          agregarAlCarrito(producto, cantidadManual);
          // Limpiar el campo de código después de agregar exitosamente
          setCodigoBarras('');
          // Enfocar el campo de código para la siguiente búsqueda
          if (inputCodigoRef.current) {
            inputCodigoRef.current.focus();
          }
        } else {
          console.log('❌ Producto no disponible');
          showError(`Producto no disponible:\n- Activo: ${producto.activo ? 'Si' : 'No'}\n- Stock: ${producto.stock_actual}`, 'Producto No Disponible');
        }
      } else {
        console.log('❌ Producto no encontrado:', data.message);
        showError(`Producto no encontrado: ${data.message}`, 'Producto No Encontrado');
      }
    } catch (error) {
      console.error('❌ Error al buscar producto:', error);
      showError(`Error al buscar producto:\n${error.message}`, 'Error de Búsqueda');
    }
  };

  // Agregar producto al carrito
  const agregarAlCarrito = (producto, cantidadManual = null) => {
    const cantidadAAgregar = cantidadManual !== null ? cantidadManual : cantidad;
    
    // Usar una función de callback para asegurar que trabajamos con el estado más reciente
    setCarrito(prevCarrito => {
      // Buscar por código de barras en lugar de ID para evitar duplicados
      const productoEnCarrito = prevCarrito.find(item => 
        item.codigo_personalizado === producto.codigo_personalizado
      );
      
      console.log('🛒 Agregando al carrito:', {
        producto: producto.nombre,
        codigo: producto.codigo_personalizado,
        cantidadAAgregar,
        productoEnCarrito: productoEnCarrito ? `${productoEnCarrito.nombre} (${productoEnCarrito.cantidad})` : 'No existe',
        carritoActual: prevCarrito.length
      });
      
      if (productoEnCarrito) {
        const nuevaCantidad = productoEnCarrito.cantidad + cantidadAAgregar;
        console.log('📈 Incrementando cantidad:', {
          cantidadAnterior: productoEnCarrito.cantidad,
          cantidadAAgregar,
          nuevaCantidad
        });
        
        // Actualizar el producto existente
        const carritoActualizado = prevCarrito.map(item =>
          item.codigo_personalizado === producto.codigo_personalizado
            ? { ...item, cantidad: nuevaCantidad }
            : item
        );
        
        console.log('✅ Carrito actualizado con cantidad incrementada:', carritoActualizado.length, 'productos');
        return carritoActualizado;
      } else {
        console.log('🆕 Agregando nuevo producto al carrito');
        const carritoActualizado = [...prevCarrito, {
          ...producto,
          cantidad: cantidadAAgregar,
          precio_unitario: parseFloat(producto.precio_venta) || 0
        }];
        
        console.log('✅ Nuevo producto agregado al carrito:', carritoActualizado.length, 'productos');
        return carritoActualizado;
      }
    });
    
         // No mostrar mensajes de alerta para una experiencia más fluida
    
    setCantidad(1);
    setCodigoBarras('');
    if (inputCodigoRef.current) {
      inputCodigoRef.current.focus();
    }
  };

  // Quitar item del carrito
  const quitarItem = (index) => {
    setCarrito(carrito.filter((_, i) => i !== index));
  };

  // Aplicar descuento TOTAL de la venta (importe fijo o porcentaje)
  const aplicarDescuento = () => {
    if (!valorDescuento || parseFloat(valorDescuento) <= 0) return;
    
    const valor = parseFloat(valorDescuento);
    let descuentoAplicado = 0;
    
    if (tipoDescuento === 'importe') {
      // Descuento por importe fijo
      descuentoAplicado = valor;
    } else if (tipoDescuento === 'porcentaje') {
      // Descuento por porcentaje del subtotal
      const subtotalBase = carrito.reduce((total, item) => 
        total + (item.precio_unitario * item.cantidad), 0
      );
      descuentoAplicado = (subtotalBase * valor) / 100;
    }
    
    // Aplicar descuento al total de la venta
    setDescuentoTotal(descuentoAplicado);
    setTipoDescuentoTotal(tipoDescuento);
    
    // Limpiar estados
    setValorDescuento('');
    setTipoDescuento('importe');
    setMostrarModalDescuento(false);
    
    console.log(`✅ Descuento TOTAL aplicado: ${tipoDescuento === 'importe' ? '$' + valor : valor + '%'} - Descuento: $${descuentoAplicado.toFixed(2)}`);
  };

  // Aplicar recargo TOTAL de la venta (importe fijo o porcentaje)
  const aplicarRecargo = () => {
    if (!valorRecargo || parseFloat(valorRecargo) <= 0) return;
    
    const valor = parseFloat(valorRecargo);
    let recargoAplicado = 0;
    
    if (tipoRecargo === 'importe') {
      // Recargo por importe fijo
      recargoAplicado = valor;
    } else if (tipoRecargo === 'porcentaje') {
      // Recargo por porcentaje del subtotal
      const subtotalBase = carrito.reduce((total, item) => 
        total + (item.precio_unitario * item.cantidad), 0
      );
      recargoAplicado = (subtotalBase * valor) / 100;
    }
    
    // Aplicar recargo al total de la venta
    setRecargoTotal(recargoAplicado);
    setTipoRecargoTotal(tipoRecargo);
    
    // Limpiar estados
    setValorRecargo('');
    setTipoRecargo('importe');
    setMostrarModalRecargo(false);
    
    console.log(`✅ Recargo TOTAL aplicado: ${tipoRecargo === 'importe' ? '$' + valor : valor + '%'} - Recargo: $${recargoAplicado.toFixed(2)}`);
  };

     // Cambiar cantidad
   const cambiarCantidad = (nuevaCantidad) => {
     if (!itemSeleccionado || nuevaCantidad <= 0) return;
     
     setCarrito(carrito.map((item, i) => 
       i === itemSeleccionado 
         ? { ...item, cantidad: nuevaCantidad }
         : item
     ));
     
     setMostrarModalCantidad(false);
     setItemSeleccionado(null);
   };

   // Cambiar cantidad directamente en línea (sin modal)
   const cambiarCantidadEnLinea = (index, nuevaCantidad) => {
     if (nuevaCantidad <= 0) return;
     
     setCarrito(prevCarrito => 
       prevCarrito.map((item, i) => 
         i === index 
           ? { ...item, cantidad: nuevaCantidad }
           : item
       )
     );
     
     console.log(`✅ Cantidad actualizada para ${carrito[index]?.nombre}: ${nuevaCantidad}`);
   };

       // Cambiar precio unitario directamente en línea (sin modal)
    const cambiarPrecioEnLinea = (index, nuevoPrecio) => {
      try {
        if (nuevoPrecio <= 0) {
          console.warn('⚠️ Precio debe ser mayor a 0');
          return;
        }
        
        setCarrito(prevCarrito => {
          const carritoActualizado = prevCarrito.map((item, i) => 
            i === index 
              ? { ...item, precio_unitario: parseFloat(nuevoPrecio) }
              : item
          );
          
          // Log con el nombre del producto actualizado
          const itemActualizado = carritoActualizado[index];
          if (itemActualizado) {
            console.log(`✅ Precio actualizado para ${itemActualizado.nombre}: $${nuevoPrecio}`);
          }
          
          return carritoActualizado;
        });
      } catch (error) {
        console.error('❌ Error al cambiar precio:', error);
      }
    };

    // Función para iniciar edición de cantidad
    const iniciarEdicionCantidad = (index, valorActual) => {
      setEditandoCantidad(index);
      setValorTemporal(valorActual.toString());
    };

    // Función para guardar cantidad editada
    const guardarCantidad = (index) => {
      const nuevaCantidad = parseInt(valorTemporal) || 1;
      if (nuevaCantidad > 0) {
        cambiarCantidadEnLinea(index, nuevaCantidad);
      }
      setEditandoCantidad(null);
      setValorTemporal('');
    };

    // Función para iniciar edición de precio
    const iniciarEdicionPrecio = (index, valorActual) => {
      setEditandoPrecio(index);
      setValorTemporal(valorActual.toFixed(2));
    };

    // Función para guardar precio editado
    const guardarPrecio = (index) => {
      try {
        const nuevoPrecio = parseFloat(valorTemporal) || 0;
        if (nuevoPrecio > 0) {
          cambiarPrecioEnLinea(index, nuevoPrecio);
          console.log(`✅ Precio guardado: $${nuevoPrecio}`);
        } else {
          console.warn('⚠️ Precio inválido, no se actualizó');
        }
      } catch (error) {
        console.error('❌ Error al guardar precio:', error);
      } finally {
        setEditandoPrecio(null);
        setValorTemporal('');
      }
    };

      // Función para cancelar edición
  const cancelarEdicion = () => {
    setEditandoCantidad(null);
    setEditandoPrecio(null);
    setValorTemporal('');
  };

  // Función para limpiar selección de item Y descuentos/recargos aplicados
  const limpiarSeleccion = () => {
    setItemSeleccionado(null);
    setMostrarModalDescuento(false);
    setMostrarModalRecargo(false);
    setMostrarModalCantidad(false);
    setValorDescuento('');
    setValorRecargo('');
    setTipoDescuento('importe');
    setTipoRecargo('importe');
    // LIMPIAR descuentos y recargos totales de la venta
    setDescuentoTotal(0);
    setRecargoTotal(0);
    setTipoDescuentoTotal('importe');
    setTipoRecargoTotal('importe');
    console.log('🧹 Descuentos y recargos limpiados - Valores reseteados a 0');
  };

    // Calcular totales incluyendo descuentos y recargos TOTALES de la venta
  const calcularTotales = () => {
    // Subtotal base (sin descuentos/recargos)
    const subtotal = carrito.reduce((total, item) =>
      total + (item.precio_unitario * item.cantidad), 0
    );
    
    // Aplicar descuento total
    const subtotalConDescuento = Math.max(0, subtotal - descuentoTotal);
    
    // Aplicar recargo total
    const subtotalConRecargo = subtotalConDescuento + recargoTotal;
    
    // Calcular IVA usando la configuración del comercio
    const iva = configComercio.aplicar_iva ? (subtotalConRecargo * configComercio.porcentaje_iva / 100) : 0;
    
    // Total final con IVA
    const total = subtotalConRecargo + iva;
    
    return { 
      subtotal, 
      descuentoTotal, 
      recargoTotal, 
      iva,
      total 
    };
  };

  // Abrir modal de pago - VERSIÓN DIRECTA
  // Abrir modal de pago - VERSIÓN HTML DIRECTO
  const abrirModalPago = () => {
    if (carrito.length === 0) return;
    
    console.log('🚀 Abriendo modal de pagos parciales HTML DIRECTO');
    
    // Crear modal HTML directo
    const modal = document.createElement('div');
    modal.id = 'modal-pagos-parciales';
    modal.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      background-color: rgba(0, 0, 0, 0.8) !important;
      z-index: 999999 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    `;
    
    const totales = calcularTotales();
    
    modal.innerHTML = `
      <div style="
        background-color: white !important;
        border-radius: 0.5rem !important;
        padding: 2rem !important;
        width: 90% !important;
        max-width: 40rem !important;
        max-height: 90vh !important;
        overflow-y: auto !important;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
      ">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; border-bottom: 1px solid #e5e7eb; padding-bottom: 0.5rem;">
          <h2 style="font-size: 1.25rem; font-weight: bold; color: #111827; margin: 0;">
            💰 Pagos Parciales
          </h2>
          <button id="cerrar-modal" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #6b7280;">×</button>
        </div>
        
        <div style="margin-bottom: 1rem; background-color: #f3f4f6; padding: 1rem; border-radius: 0.5rem;">
          <h3 style="font-size: 1rem; font-weight: 600; color: #374151; margin: 0 0 0.5rem 0;">
            📊 Resumen de la Venta
          </h3>
          <div style="display: flex; justify-content: space-between; align-items: center; padding: 0.5rem; background-color: white; border-radius: 0.25rem;">
            <span style="font-size: 0.875rem; font-weight: 500; color: #374151;">Total:</span>
            <span style="font-size: 1.25rem; font-weight: bold; color: #1f2937;">$${totales.total.toFixed(2)}</span>
          </div>
        </div>
        
        <div style="margin-bottom: 1rem;">
          <h3 style="font-size: 1rem; font-weight: 600; color: #374151; margin: 0 0 0.5rem 0;">
            💳 Agregar Pago
          </h3>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; margin-bottom: 0.5rem;">
            <select id="metodo-pago" style="padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.375rem; font-size: 0.875rem;">
              <option value="efectivo">Efectivo</option>
              <option value="tarjeta_debito">Tarjeta Débito</option>
              <option value="tarjeta_credito">Tarjeta Crédito</option>
              <option value="mercado_pago">Mercado Pago</option>
              <option value="transferencia">Transferencia</option>
            </select>
            <input type="number" id="monto-pago" step="0.01" min="0.01" max="${totales.total}" placeholder="Monto" style="padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.375rem; font-size: 0.875rem;">
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; margin-bottom: 0.5rem;">
            <input type="text" id="referencia-pago" placeholder="Referencia (opcional)" style="padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.375rem; font-size: 0.875rem;">
            <input type="text" id="observaciones-pago" placeholder="Observaciones (opcional)" style="padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.375rem; font-size: 0.875rem;">
          </div>
          <button id="agregar-pago" style="width: 100%; padding: 0.75rem; background-color: #3b82f6; color: white; border: none; border-radius: 0.375rem; font-weight: 600; cursor: pointer; font-size: 0.875rem;">
            ➕ Agregar Pago
          </button>
        </div>
        
        <div id="lista-pagos" style="margin-bottom: 1rem; max-height: 200px; overflow-y: auto;">
          <!-- Los pagos se agregarán aquí dinámicamente -->
        </div>
        
        <div style="margin-bottom: 1rem; padding: 1rem; background-color: #fef3c7; border: 1px solid #fbbf24; border-radius: 0.5rem;">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="font-size: 0.875rem; font-weight: 600; color: #92400e;">Saldo Pendiente:</span>
            <span id="saldo-pendiente" style="font-size: 1rem; font-weight: bold; color: #d97706;">$${totales.total.toFixed(2)}</span>
          </div>
        </div>
        
        <div style="display: flex; justify-content: center; gap: 0.75rem;">
          <button id="cancelar-venta" style="padding: 0.75rem 1.5rem; background-color: #6b7280; color: white; border: none; border-radius: 0.375rem; font-weight: 600; cursor: pointer; font-size: 0.875rem;">
            ❌ Cancelar
          </button>
          <button id="finalizar-venta" style="padding: 0.75rem 1.5rem; background-color: #10b981; color: white; border: none; border-radius: 0.375rem; font-weight: 600; cursor: pointer; font-size: 0.875rem;">
            ✅ Finalizar Venta
          </button>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // Variables para manejar pagos
    let pagosParciales = [];
    let saldoPendiente = totales.total;
    
    // Función para actualizar la UI
    const actualizarUI = () => {
      const totalPagos = pagosParciales.reduce((sum, pago) => sum + pago.monto, 0);
      saldoPendiente = totales.total - totalPagos;
      
      document.getElementById('saldo-pendiente').textContent = `$${saldoPendiente.toFixed(2)}`;
      document.getElementById('finalizar-venta').disabled = saldoPendiente > 0.01;
      document.getElementById('finalizar-venta').style.backgroundColor = saldoPendiente <= 0.01 ? '#10b981' : '#9ca3af';
      
      // Actualizar lista de pagos
      const listaPagos = document.getElementById('lista-pagos');
      listaPagos.innerHTML = pagosParciales.map((pago, index) => `
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 0.5rem; background-color: #f9fafb; border: 1px solid #e5e7eb; border-radius: 0.375rem; margin-bottom: 0.5rem;">
          <div>
            <span style="font-weight: 600; color: #374151;">${pago.metodo_pago}</span>
            <span style="color: #6b7280; margin-left: 0.5rem;">$${pago.monto.toFixed(2)}</span>
            ${pago.referencia ? `<span style="color: #6b7280; margin-left: 0.5rem;">(${pago.referencia})</span>` : ''}
          </div>
          <button onclick="eliminarPago(${index})" style="background: none; border: none; color: #dc2626; cursor: pointer; font-size: 1.2rem;">×</button>
        </div>
      `).join('');
    };
    
    // Función para eliminar pago
    window.eliminarPago = (index) => {
      pagosParciales.splice(index, 1);
      actualizarUI();
    };
    
    // Event listeners
    document.getElementById('cerrar-modal').onclick = () => {
      document.body.removeChild(modal);
    };
    
    document.getElementById('cancelar-venta').onclick = () => {
      document.body.removeChild(modal);
    };
    
    document.getElementById('agregar-pago').onclick = () => {
      const metodo = document.getElementById('metodo-pago').value;
      const monto = parseFloat(document.getElementById('monto-pago').value);
      const referencia = document.getElementById('referencia-pago').value;
      const observaciones = document.getElementById('observaciones-pago').value;
      
      if (!monto || monto <= 0) {
        showError('Ingresa un monto válido', 'Monto Inválido');
        return;
      }
      
      if (monto > saldoPendiente) {
        showError('El monto excede el saldo pendiente', 'Monto Excedido');
        return;
      }
      
      pagosParciales.push({
        metodo_pago: metodo,
        monto: monto,
        referencia: referencia,
        observaciones: observaciones
      });
      
      // Limpiar campos
      document.getElementById('monto-pago').value = '';
      document.getElementById('referencia-pago').value = '';
      document.getElementById('observaciones-pago').value = '';
      
      actualizarUI();
    };
    
    document.getElementById('finalizar-venta').onclick = async () => {
      if (saldoPendiente > 0.01) {
        showError('Debes completar el pago total', 'Pago Incompleto');
        return;
      }
      
      // Cerrar modal
      document.body.removeChild(modal);
      
      // Finalizar venta con pagos parciales
      try {
        setProcesandoVenta(true);
        
        const ticketActual = numeroTicket;
        setNumeroTicket(prev => prev + 1);
        
        const venta = {
          id: Date.now(),
          numeroTicket: ticketActual,
          fecha: new Date().toISOString(),
          fechaLegible: new Date().toLocaleDateString('es-AR') + ' ' + new Date().toLocaleTimeString('es-AR'),
          items: carrito.map(item => ({
            ...item,
            stockAnterior: item.stock || 0,
            stockNuevo: Math.max(0, (item.stock || 0) - item.cantidad)
          })),
          subtotal: totales.subtotal,
          descuentoTotal: descuentoTotal,
          recargoTotal: recargoTotal,
          total: totales.total,
          montoRecibido: totales.total,
          cambio: 0,
          metodoPago: 'pagos_parciales',
          observaciones: observaciones,
          comercioId: configComercio.id,
          pagosParciales: pagosParciales
        };
        
        console.log('📊 Venta con pagos parciales:', venta);
        
        // Actualizar stock
        await actualizarStockProductos(venta.items);
        
        // Enviar al backend
        await enviarVentaAlBackend(venta);
        
        // Guardar en localStorage
        guardarVentaEnLocalStorage(venta);
        
        // Mostrar comprobante
        setVentaCompletada(venta);
        setMostrarComprobante(true);
        
        // Imprimir
        imprimirComprobante(venta);
        
        // Limpiar sistema
        limpiarSistemaPostVenta();
        
        console.log('✅ Venta con pagos parciales finalizada exitosamente');
        
      } catch (error) {
        console.error('❌ Error al finalizar venta:', error);
        showError('Error al finalizar la venta. Intente nuevamente.', 'Error de Venta');
        // No limpiar el carrito en caso de error para que el usuario pueda reintentar
      } finally {
        setProcesandoVenta(false);
      }
    };
    
    // Inicializar UI
    actualizarUI();
    
    // Focus en el campo de monto
    setTimeout(() => {
      document.getElementById('monto-pago').focus();
    }, 100);
  };

  // Calcular cambio
  const calcularCambio = (monto) => {
    const total = calcularTotales().total;
    const cambioCalculado = monto - total;
    setCambio(cambioCalculado >= 0 ? cambioCalculado : 0);
  };

  // Finalizar venta - NUEVA IMPLEMENTACIÓN COMPLETA
  const finalizarVenta = async () => {
    if (carrito.length === 0) return;
    
    try {
      setProcesandoVenta(true);
      
      // 1. GENERAR NÚMERO DE TICKET CONSECUTIVO
      const ticketActual = numeroTicket;
      setNumeroTicket(prev => prev + 1);
      
      // 2. CALCULAR TOTALES FINALES
      const totales = calcularTotales();
      
      // 3. CREAR OBJETO DE VENTA COMPLETA
      const venta = {
        id: Date.now(),
        numeroTicket: ticketActual,
        fecha: new Date().toISOString(),
        fechaLegible: new Date().toLocaleDateString('es-AR') + ' ' + new Date().toLocaleTimeString('es-AR'),
        items: carrito.map(item => ({
          ...item,
          stockAnterior: item.stock || 0,
          stockNuevo: Math.max(0, (item.stock || 0) - item.cantidad)
        })),
        subtotal: totales.subtotal,
        descuentoTotal: descuentoTotal,
        tipoDescuentoTotal: tipoDescuentoTotal,
        recargoTotal: recargoTotal,
        tipoRecargoTotal: tipoRecargoTotal,
        total: totales.total,
        montoRecibido: montoRecibido,
        cambio: cambio,
        metodoPago: pagosParciales.length > 0 ? 'pagos_parciales' : 'efectivo',
        observaciones: observaciones,
        comercioId: configComercio.id, // ID del comercio actual
        pagosParciales: pagosParciales // Incluir pagos parciales
      };
      
      // 4. DESCONTAR STOCK DE PRODUCTOS
      await actualizarStockProductos(venta.items);
      
      // 5. ENVIAR VENTA AL BACKEND
      await enviarVentaAlBackend(venta);
      
      // 6. GUARDAR VENTA EN LOCALSTORAGE
      guardarVentaEnLocalStorage(venta);
      
      // 6. GENERAR Y MOSTRAR COMPROBANTE
      setVentaCompletada(venta);
      setMostrarComprobante(true);
      
      // 7. IMPRIMIR COMPROBANTE
      imprimirComprobante(venta);
      
      // 8. LIMPIAR SISTEMA PARA NUEVA VENTA
      limpiarSistemaPostVenta();
      
      // 9. CERRAR MODAL DE PAGO
      setMostrarModalPago(false);
      
      console.log('✅ Venta finalizada exitosamente:', venta);
      
    } catch (error) {
      console.error('❌ Error al finalizar venta:', error);
      showError('Error al finalizar la venta. Intente nuevamente.', 'Error de Venta');
    } finally {
      setProcesandoVenta(false);
    }
  };


  // ===== FUNCIONES AUXILIARES PARA CIERRE DE VENTA =====
  
  // 1. ENVIAR VENTA AL BACKEND
  const enviarVentaAlBackend = async (venta) => {
    try {
      console.log('🚀 Enviando venta al backend...');
      
      const token = getSecureToken();
      if (!token) {
        throw new Error('Token no disponible');
      }
      
      // Preparar datos para el backend
      const datosVenta = {
        token: token,
        comercio_id: configComercio.id,
        numero_ticket: venta.numeroTicket,
        cliente_id: 'CONSUMIDOR_FINAL',
        fecha_venta: venta.fecha,
        subtotal: venta.subtotal,
        descuento: venta.descuentoTotal,
        iva: 0, // Por ahora sin IVA
        total: venta.total,
        cambio_entregado: venta.cambio,
        metodo_pago: venta.metodoPago,
        observaciones: venta.observaciones,
        items: venta.items.map(item => ({
          producto_id: item.id,
          cantidad: item.cantidad,
          precio_unitario: item.precio_unitario,
          precio_original: item.precio_original || item.precio_unitario,
          descuento: item.descuento || 0,
          total_linea: item.precio_unitario * item.cantidad
        })),
        pagos_parciales: venta.pagosParciales.map(pago => ({
          metodo_pago: pago.metodo_pago,
          monto: pago.monto,
          referencia: pago.referencia || null,
          observaciones: pago.observaciones || null
        }))
      };
      
      console.log('📤 Datos de venta preparados:', datosVenta);
      
        const response = await fetch(`${getApiBaseUrl()}/ventas_guardar.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosVenta)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        console.log('❌ Error del servidor:', errorData);
        if (errorData.debug_info) {
          console.log('🔍 Debug info:', errorData.debug_info);
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const resultado = await response.json();
      
      if (resultado.success) {
        console.log('✅ Venta guardada en backend:', resultado);
        if (resultado.debug_info) {
          console.log('🔍 Debug info:', resultado.debug_info);
        }
        showSuccess('Venta guardada correctamente en el sistema');
      } else {
        console.log('❌ Error del servidor:', resultado);
        if (resultado.debug_info) {
          console.log('🔍 Debug info:', resultado.debug_info);
        }
        throw new Error(resultado.error || 'Error desconocido del servidor');
      }
      
    } catch (error) {
      console.error('❌ Error al enviar venta al backend:', error);
      showError(`Error al guardar venta: ${error.message}`, 'Error de Guardado');
      throw error; // Re-lanzar para que se maneje en finalizarVenta
    }
  };
  
  // 2. ACTUALIZAR STOCK DE PRODUCTOS
  const actualizarStockProductos = async (items) => {
    try {
      console.log('📦 Actualizando stock de productos...');
      
      for (const item of items) {
        const nuevoStock = Math.max(0, (item.stock || 0) - item.cantidad);
        
        // Actualizar stock en el estado local
        setProductos(prevProductos => 
          prevProductos.map(producto => 
            producto.id === item.id 
              ? { ...producto, stock: nuevoStock }
              : producto
          )
        );
        
        console.log(`✅ Stock actualizado: ${item.nombre} - Anterior: ${item.stock}, Nuevo: ${nuevoStock}`);
      }
      
      console.log('✅ Stock de todos los productos actualizado');
    } catch (error) {
      console.error('❌ Error al actualizar stock:', error);
      throw error;
    }
  };

  // 2. GUARDAR VENTA EN LOCALSTORAGE
  const guardarVentaEnLocalStorage = (venta) => {
    try {
      // Obtener ventas existentes
      const ventasExistentes = JSON.parse(localStorage.getItem('ventas_sinfilas') || '[]');
      
      // Agregar nueva venta
      ventasExistentes.push(venta);
      
      // Guardar en localStorage
      localStorage.setItem('ventas_sinfilas', JSON.stringify(ventasExistentes));
      
      console.log('💾 Venta guardada en localStorage:', venta.numeroTicket);
      
      // Actualizar estadísticas
      actualizarEstadisticasVentas(ventasExistentes);
      
    } catch (error) {
      console.error('❌ Error al guardar venta en localStorage:', error);
    }
  };

  // 3. ACTUALIZAR ESTADÍSTICAS DE VENTAS
  const actualizarEstadisticasVentas = (ventas) => {
    try {
      const estadisticas = {
        totalVentas: ventas.length,
        fechaUltimaActualizacion: new Date().toISOString(),
        ventasPorDia: {},
        productosMasVendidos: {},
        totalIngresos: 0
      };

      ventas.forEach(venta => {
        // Total de ingresos
        estadisticas.totalIngresos += venta.total;
        
        // Ventas por día
        const fecha = venta.fechaLegible.split(' ')[0];
        estadisticas.ventasPorDia[fecha] = (estadisticas.ventasPorDia[fecha] || 0) + 1;
        
        // Productos más vendidos
        venta.items.forEach(item => {
          estadisticas.productosMasVendidos[item.nombre] = 
            (estadisticas.productosMasVendidos[item.nombre] || 0) + item.cantidad;
        });
      });

      localStorage.setItem('estadisticas_sinfilas', JSON.stringify(estadisticas));
      console.log('📊 Estadísticas actualizadas:', estadisticas);
      
    } catch (error) {
      console.error('❌ Error al actualizar estadísticas:', error);
    }
  };

  // 4. IMPRIMIR COMPROBANTE
  const imprimirComprobante = async (venta) => {
    try {
      console.log('🖨️ Preparando impresión del comprobante...');
      
      // Generar HTML del comprobante (ahora es async)
      const htmlComprobante = await generarHTMLComprobante(venta);
      
      // Crear ventana de impresión
      const ventanaImpresion = window.open('', '_blank', 'width=600,height=600');
      
      if (ventanaImpresion) {
        console.log('✅ Ventana de impresión abierta correctamente');
        
        // Escribir el HTML en la ventana
        ventanaImpresion.document.write(htmlComprobante);
        ventanaImpresion.document.close();
        
        console.log('📄 HTML escrito en la ventana de impresión');
        
        // IMPRIMIR INMEDIATAMENTE - Sin esperas ni dependencias de imágenes
        setTimeout(() => {
          try {
            ventanaImpresion.print();
            console.log('✅ Comprobante enviado a impresora');
          } catch (printError) {
            console.error('❌ Error al ejecutar print():', printError);
          }
        }, 500); // Solo 500ms para que se escriba el HTML
        
      } else {
        console.log('❌ No se pudo abrir ventana de impresión - Posible bloqueo de ventanas emergentes');
        alert('No se pudo abrir la ventana de impresión. Verifica que el navegador no esté bloqueando ventanas emergentes.');
      }
      
    } catch (error) {
      console.error('❌ Error al imprimir comprobante:', error);
      alert('Error al imprimir el comprobante: ' + error.message);
    }
  };

  const generarHTMLComprobante = async (venta) => {
    // Cargar datos reales del comercio desde la API
    let datosComercio = {
      fantasia: 'SIVOL',
      razonSocial: 'SIVOL',
      direccion: 'Dirección del comercio',
      ciudad: 'Ciudad del comercio',
      codigoPostal: '0000',
      whatsapp: 'Sin WhatsApp',
      condicionIva: 'Monotributo',
      cuit: 'Sin CUIT',
      iibb: 'Exento',
      pie_ticket: '¡Gracias por su compra!',
      tipoImpresora: 'termica_58mm',
      margenIzquierdo: 5,
      margenDerecho: 5,
      margenSuperior: 5,
      margenInferior: 5,
      orientacion: 'portrait',
      calidad: 'normal'
    };

    try {
      const token = obtenerTokenSeguro();
      if (token) {
        const response = await fetch(`https://www.sinfilas.com.ar/sf3/ventas/api/comercios_perfil_cargar.php?token=${token}`);
        const data = await response.json();
        
        if (data.success && data.data) {
          const comercio = data.data;
          datosComercio = {
            fantasia: comercio.fantasia || 'SIVOL',
            razonSocial: comercio.empresa || comercio.fantasia || 'SIVOL',
            direccion: comercio.direccion || 'Sin dirección',
            ciudad: comercio.ciudad || 'Sin ciudad',
            codigoPostal: comercio.codpostal || '0000',
            whatsapp: comercio.whatsapp || 'Sin WhatsApp',
            condicionIva: comercio.condicion_iva || 'Monotributo',
            cuit: comercio.cuit || 'Sin CUIT',
            iibb: comercio.iibb || 'Exento',
            pie_ticket: comercio.pie_ticket || '¡Gracias por su compra!',
            tipoImpresora: comercio.impresora_tickets || 'termica_58mm',
            margenIzquierdo: comercio.margen_izquierdo || 5,
            margenDerecho: comercio.margen_derecho || 5,
            margenSuperior: comercio.margen_superior || 5,
            margenInferior: comercio.margen_inferior || 5,
            orientacion: comercio.orientacion_papel || 'portrait',
            calidad: comercio.calidad_impresion || 'normal'
          };
          console.log('✅ Datos del comercio cargados desde API:', datosComercio);
        } else {
          console.warn('⚠️ API no devolvió datos válidos, usando datos por defecto');
        }
      }
    } catch (error) {
      console.warn('⚠️ Error al cargar datos del comercio, usando datos por defecto:', error);
    }

    // Aplicar estilos según el tipo de impresora del comercio
    const esImpresora58mm = datosComercio.tipoImpresora === 'termica_58mm';
    const estilosImpresora = {
      maxWidth: esImpresora58mm ? '58mm' : '80mm',
      fontSize: esImpresora58mm ? '8px' : '10px',
      lineHeight: esImpresora58mm ? '1.0' : '1.2',
      padding: esImpresora58mm ? '1px' : '2px',
      margin: '0'
    };
      
      const html = `
      <!DOCTYPE html>
      <html lang="es">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Ticket #${venta.numeroTicket} - ${datosComercio.fantasia}</title>
            <style>
              body { 
                font-family: 'Courier New', monospace; 
                font-size: ${estilosImpresora.fontSize}; 
                font-weight: bold;
                margin: ${datosComercio.margenSuperior}mm ${datosComercio.margenDerecho}mm ${datosComercio.margenInferior}mm ${datosComercio.margenIzquierdo}mm; 
                padding: ${estilosImpresora.padding}; 
                max-width: ${estilosImpresora.maxWidth};
                line-height: ${estilosImpresora.lineHeight};
              }
              * {
                font-weight: bold !important;
              }
          .header { text-align: center; border-bottom: 1px solid #000; padding-bottom: 5px; margin-bottom: 8px; }
          .ticket-info { margin-bottom: 8px; }
          .items { margin-bottom: 8px; }
          .item { display: flex; justify-content: space-between; margin-bottom: 2px; }
          .totals { border-top: 1px solid #000; padding-top: 5px; margin-top: 8px; }
          .total-row { display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 1px; }
          .footer { text-align: center; margin-top: 10px; font-size: 10px; }
          .separator { border-top: 1px solid #000; margin: 5px 0; }
          .cliente-info { margin: 8px 0; }
          @media print { 
            body { 
              margin: ${datosComercio.margenSuperior}mm ${datosComercio.margenDerecho}mm ${datosComercio.margenInferior}mm ${datosComercio.margenIzquierdo}mm; 
              transform: ${datosComercio.orientacion === 'landscape' ? 'rotate(90deg)' : 'none'};
            }
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h2 style="margin: 0 0 5px 0;">${datosComercio.fantasia}</h2>
        </div>
        
        <div class="ticket-info">
          <p style="margin: 0 0 2px 0;"><strong>Ticket #${venta.numeroTicket}</strong></p>
          <p style="margin: 0 0 2px 0;">Fecha: ${venta.fechaLegible}</p>
          <p style="margin: 0 0 2px 0;">${datosComercio.razonSocial}</p>
          <p style="margin: 0 0 2px 0;">${datosComercio.direccion}</p>
          <p style="margin: 0 0 2px 0;">${datosComercio.ciudad} - ${datosComercio.codigoPostal}</p>
          <p style="margin: 0 0 2px 0;">WhatsApp: ${datosComercio.whatsapp}</p>
          <p style="margin: 0 0 2px 0;">Condición IVA: ${datosComercio.condicionIva}</p>
          <p style="margin: 0 0 2px 0;">CUIT: ${datosComercio.cuit}</p>
          <p style="margin: 0 0 2px 0;">IIBB: ${datosComercio.iibb}</p>
        </div>

        <div class="separator"></div>

        <div class="cliente-info">
          <p style="margin: 0 0 2px 0;"><strong>Consumidor Final</strong></p>
          <p style="margin: 0 0 2px 0;">Sin dirección</p>
          <p style="margin: 0 0 2px 0;">Condiciones de venta: Consumidor Final</p>
          <p style="margin: 0 0 2px 0;">VTAG 00000000</p>
        </div>

        <div class="separator"></div>

        <div class="items">
          <h4 style="margin: 0 0 5px 0;">ITEMS VENDIDOS:</h4>
          
          <!-- Títulos de las columnas -->
          <div class="item-header" style="display: flex; justify-content: space-between; font-weight: bold; border-bottom: 1px solid #000; padding-bottom: 3px; margin-bottom: 5px;">
            <span style="flex: 2;">DESCRIPCIÓN</span>
            <span style="flex: 1; text-align: center;">CANTIDAD</span>
            <span style="flex: 1; text-align: right;">IMPORTE</span>
          </div>
          
          <!-- Items de la venta -->
          ${venta.items.map(item => `
            <div class="item" style="margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 4px;">
              <div style="font-weight: bold; margin-bottom: 2px;">${item.nombre}</div>
              <div style="font-size: 0.9em; color: #666; margin-bottom: 2px;">${item.cantidad} x $${item.precio_unitario.toFixed(2)}</div>
              <div style="font-weight: bold; text-align: right; color: #000;">$${(item.precio_unitario * item.cantidad).toFixed(2)}</div>
            </div>
          `).join('')}
        </div>
        
        <div class="totals">
          <div class="total-row">
            <span>Subtotal:</span>
            <span>$${venta.subtotal.toFixed(2)}</span>
          </div>
          ${venta.descuentoTotal > 0 ? `
            <div class="total-row">
              <span>Descuento (${venta.tipoDescuentoTotal}):</span>
              <span>-$${venta.descuentoTotal.toFixed(2)}</span>
            </div>
          ` : ''}
          ${venta.recargoTotal > 0 ? `
            <div class="total-row">
              <span>Recargo (${venta.tipoRecargoTotal}):</span>
              <span>+$${venta.recargoTotal.toFixed(2)}</span>
            </div>
          ` : ''}
          <div class="total-row">
            <span>TOTAL:</span>
            <span>$${venta.total.toFixed(2)}</span>
          </div>
          <div class="total-row">
            <span>Recibido:</span>
            <span>$${venta.montoRecibido.toFixed(2)}</span>
          </div>
          <div class="total-row">
            <span>Cambio:</span>
            <span>$${venta.cambio.toFixed(2)}</span>
          </div>
        </div>

        ${venta.observaciones ? `
        <div class="observaciones" style="margin-top: 8px; padding: 5px; border: 1px solid #ccc; background-color: #f9f9f9;">
          <h4 style="margin: 0 0 3px 0; font-weight: bold;">OBSERVACIONES:</h4>
          <p style="margin: 0; font-style: italic;">${venta.observaciones}</p>
        </div>
        ` : ''}

        <div class="footer">
          <p style="margin: 0 0 2px 0;">${datosComercio.pie_ticket || '¡Gracias por su compra!'}</p>
          <p style="margin: 0;">${datosComercio.fantasia} - Sistema de Ventas</p>
        </div>
      </body>
      </html>
    `;
    
    return html;
  };

  // Función auxiliar para ajustar estilos según el tipo de impresora
  const ajustarEstilosSegunImpresora = (tipoImpresora) => {
    switch (tipoImpresora) {
      case 'termica_58mm':
        return {
          fontSize: '10px',
          maxWidth: '58mm'
        };
      case 'termica_80mm':
        return {
          fontSize: '12px',
          maxWidth: '80mm'
        };
      case 'A4':
        return {
          fontSize: '14px',
          maxWidth: '210mm'
        };
      default:
        return {
          fontSize: '12px',
          maxWidth: '80mm'
        };
    }
  };

  // Función de fallback si falla la carga de datos del comercio
  const generarHTMLComprobanteFallback = (venta) => {
    const html = `
      <!DOCTYPE html>
      <html lang="es">
      <head>
        <meta charset="UTF-8">
        <title>Ticket #${venta.numeroTicket} - SinFilas</title>
        <style>
          body { font-family: 'Courier New', monospace; font-size: 12px; margin: 0; padding: 10px; }
          .header { text-align: center; border-bottom: 1px solid #000; padding-bottom: 10px; margin-bottom: 15px; }
          .ticket-info { margin-bottom: 15px; }
          .items { margin-bottom: 15px; }
          .item { display: flex; justify-content: space-between; margin-bottom: 5px; }
          .totals { border-top: 1px solid #000; padding-top: 10px; margin-top: 15px; }
          .total-row { display: flex; justify-content: space-between; font-weight: bold; }
          .footer { text-align: center; margin-top: 20px; font-size: 10px; }
          .separator { border-top: 1px solid #000; margin: 10px 0; }
          .cliente-info { margin: 15px 0; }
        </style>
      </head>
      <body>
        <div class="header">
          <h2>SINFILAS</h2>
        </div>
        
        <div class="ticket-info">
          <p><strong>Ticket #${venta.numeroTicket}</strong></p>
          <p>Fecha: ${venta.fechaLegible}</p>
          <p>Error al cargar datos del comercio</p>
        </div>

        <div class="separator"></div>

        <div class="cliente-info">
          <p><strong>Consumidor Final</strong></p>
          <p>Sin dirección</p>
          <p>Condiciones de venta: Consumidor Final</p>
          <p>VTAG 00000000</p>
        </div>

        <div class="separator"></div>

        <div class="items">
          <h4>ITEMS VENDIDOS:</h4>
          ${venta.items.map(item => `
            <div class="item">
              <span>${item.nombre} x${item.cantidad}</span>
              <span>$${(item.precio_unitario * item.cantidad).toFixed(2)}</span>
            </div>
          `).join('')}
        </div>
        
        <div class="totals">
          <div class="total-row">
            <span>Subtotal:</span>
            <span>$${venta.subtotal.toFixed(2)}</span>
          </div>
          ${venta.descuentoTotal > 0 ? `
            <div class="total-row">
              <span>Descuento (${venta.tipoDescuentoTotal}):</span>
              <span>-$${venta.descuentoTotal.toFixed(2)}</span>
            </div>
          ` : ''}
          ${venta.recargoTotal > 0 ? `
            <div class="total-row">
              <span>Recargo (${venta.tipoRecargoTotal}):</span>
              <span>+$${venta.recargoTotal.toFixed(2)}</span>
            </div>
          ` : ''}
          <div class="total-row">
            <span>TOTAL:</span>
            <span>$${venta.total.toFixed(2)}</span>
          </div>
          <div class="total-row">
            <span>Recibido:</span>
            <span>$${venta.montoRecibido.toFixed(2)}</span>
          </div>
          <div class="total-row">
            <span>Cambio:</span>
            <span>$${venta.cambio.toFixed(2)}</span>
          </div>
        </div>

        ${venta.observaciones ? `
        <div class="observaciones" style="margin-top: 15px; padding: 10px; border: 1px solid #ccc; background-color: #f9f9f9;">
          <h4 style="margin: 0 0 5px 0; font-weight: bold;">OBSERVACIONES:</h4>
          <p style="margin: 0; font-style: italic;">${venta.observaciones}</p>
        </div>
        ` : ''}

        <div class="footer">
          <p>¡Gracias por su compra!</p>
          <p>SinFilas - Sistema de Ventas</p>
        </div>
      </body>
      </html>
    `;
    
    console.log('⚠️ Usando HTML de fallback (datos básicos)');
    return html;
  };

  // 6. LIMPIAR SISTEMA POST-VENTA
  const limpiarSistemaPostVenta = () => {
    try {
      console.log('🧹 Limpiando sistema para nueva venta...');
      
      // Limpiar carrito
      setCarrito([]);
      
      // Resetear descuentos y recargos
      setDescuentoTotal(0);
      setRecargoTotal(0);
      setTipoDescuentoTotal('importe');
      setTipoRecargoTotal('importe');
      
      // Limpiar campos de entrada
      setCodigoBarras('');
      setCantidad(1);
      setMontoRecibido(0);
      setCambio(0);
      setObservaciones('');
      
      // Resetear selección
      setItemSeleccionado(null);
      
      // Resetear edición
      setEditandoCantidad(null);
      setEditandoPrecio(null);
      setValorTemporal('');
      
      console.log('✅ Sistema limpiado para nueva venta');
      
      // Enfocar automáticamente el campo de código después de una venta
      setTimeout(() => {
        if (inputCodigoRef.current) {
          inputCodigoRef.current.focus();
          console.log('🎯 Campo de código enfocado automáticamente');
        }
      }, 100);
      
    } catch (error) {
      console.error('❌ Error al limpiar sistema:', error);
    }
  };





  // Función para iniciar scanner automático
  const iniciarScanner = async () => {
    try {
      
      setScanning(true);
      setShowCamera(true);
      setError('');
      
      console.log('🔍 Iniciando scanner automático...');
      
             // Inicializar scanner de códigos de barras
       const { BrowserMultiFormatReader } = await import('@zxing/library');
       scannerRef.current = new BrowserMultiFormatReader();
      
      // Configurar video
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { 
          facingMode: 'environment',
          width: { ideal: 1280 },
          height: { ideal: 720 }
        } 
      });
      
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        console.log('✅ Video configurado correctamente');
      }
      
      // Iniciar detección automática
      console.log('🎯 Iniciando detección de códigos...');
      
                     // Configurar el scanner con más opciones
        scannerRef.current.decodeFromVideoDevice(
          undefined,
          videoRef.current,
                     (result, error) => {
             if (result) { // Siempre procesar si hay resultado
               const codigoDetectado = result.text;
          const tiempoActual = Date.now();
          
               console.log('🎯 Código detectado automáticamente:', codigoDetectado);
               
               // Verificar si ya estamos procesando este código o si es muy reciente
               if (procesandoCodigo || 
                   (codigoDetectado === ultimoCodigoProcesado && 
                    (tiempoActual - tiempoUltimaLectura) < 5000)) {
                 console.log('⚠️ Código ya procesado o en proceso, ignorando...');
            return;
          }
          
                             // Marcar que estamos procesando este código
          setProcesandoCodigo(true);
               
               // NO detener el scanner, solo marcar que estamos procesando
               console.log('⏸️ Procesando código, pausando nuevas lecturas por 3 segundos');
              
              // Actualizar control de duplicados
          setUltimoCodigoProcesado(codigoDetectado);
          setTiempoUltimaLectura(tiempoActual);
         
              // Establecer el código de barras
              setCodigoBarras(codigoDetectado);
              
              // Reproducir beep de confirmación
          reproducirBeep();
         
              // Buscar producto automáticamente
              console.log('🔍 Buscando producto automáticamente...');
              console.log('📊 Estado del carrito ANTES de agregar:', carrito.length, 'productos');
         
              // Procesar el producto y luego reactivar el scanner
          buscarYAgregarProducto(codigoDetectado, 1).then(() => {
                // Log después de procesar
            setTimeout(() => {
                  console.log('📊 Estado del carrito DESPUÉS de agregar:', carrito.length, 'productos');
                  console.log('📋 Productos en carrito:', carrito.map(item => `${item.nombre}: ${item.cantidad}`));
                }, 100);
                
                                 // Reactivar detección después de 3 segundos EXACTOS
                 setTimeout(() => {
                   if (showCamera) {
                     // Solo resetear el flag de procesamiento
            setProcesandoCodigo(false);
                     console.log('✅ Detección reactivada después de 3 segundos');
                   }
                 }, 3000);
               }).catch(() => {
                 // En caso de error, reactivar después de 2 segundos
            setTimeout(() => {
                   if (showCamera) {
                     setProcesandoCodigo(false);
                     console.log('✅ Detección reactivada después de error');
                   }
                 }, 2000);
               });
            }
            if (error && error.name !== 'NotFoundException') {
              console.log('⚠️ Error de scanner:', error);
            }
          }
        );
      
      console.log('✅ Scanner iniciado con detección automática');
    } catch (err) {
      console.error('❌ Error al iniciar scanner:', err);
      setError('Error al iniciar scanner: ' + err.message);
      setScanning(false);
      setShowCamera(false);
    }
  };

  // Función para cerrar cámara
  const cerrarCamara = () => {
    console.log('🔒 Cerrando cámara y scanner...');
    
    // Detener scanner si está activo
    if (scannerRef.current) {
      try {
        scannerRef.current.reset();
        console.log('✅ Scanner detenido');
      } catch (err) {
        console.log('⚠️ Error al detener scanner:', err);
      }
    }
    
    // Detener stream de video
    if (videoRef.current?.srcObject) {
      try {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => {
          track.stop();
          console.log('✅ Track detenido:', track.kind);
        });
        videoRef.current.srcObject = null;
      } catch (err) {
        console.log('⚠️ Error al detener video:', err);
      }
    }
    
    // Resetear estados
    setScanning(false);
    setShowCamera(false);
    
    console.log('✅ Cámara cerrada completamente');
  };

  // Limpiar duplicados del carrito (consolidar productos por código de barras)
  const limpiarDuplicados = () => {
    const productosConsolidados = [];
    const codigosProcesados = new Set();
    
    carrito.forEach(item => {
      if (!codigosProcesados.has(item.codigo_personalizado)) {
        // Buscar todos los items con el mismo código
        const itemsMismoCodigo = carrito.filter(i => i.codigo_personalizado === item.codigo_personalizado);
        const cantidadTotal = itemsMismoCodigo.reduce((total, i) => total + i.cantidad, 0);
        
        // Crear un solo item con la cantidad total
        productosConsolidados.push({
          ...item,
          cantidad: cantidadTotal
        });
        
        codigosProcesados.add(item.codigo_personalizado);
      }
    });
    
    setCarrito(productosConsolidados);
    console.log('🧹 Carrito limpiado de duplicados:', productosConsolidados.length, 'productos únicos');
  };

  // Nueva venta
  const nuevaVenta = () => {
    setCarrito([]);
    setCodigoBarras('');
    setCantidad(1);
    setDescuento(0);
    setItemSeleccionado(null);
    setObservaciones('');
    setNumeroComprobante('');
    setMostrarModalPago(false);
    setMostrarModalDescuento(false);
    setMostrarModalCantidad(false);
    setMostrarModalRecargo(false);
    setValorDescuento('');
    setValorRecargo('');
    setTipoDescuento('importe');
    setTipoRecargo('importe');
    // Limpiar descuentos y recargos totales de la venta
    setDescuentoTotal(0);
    setRecargoTotal(0);
    setTipoDescuentoTotal('importe');
    setTipoRecargoTotal('importe');
    if (inputCodigoRef.current) {
      inputCodigoRef.current.focus();
    }
  };

  // Obtener totales para el renderizado
  const { subtotal, total } = calcularTotales();
  
  // Inicializar saldo pendiente cuando se abre el modal
  useEffect(() => {
    if (mostrarModalPago) {
      setSaldoPendiente(total);
      setTotalPagosParciales(0);
      setPagosParciales([]);
    }
  }, [mostrarModalPago, total]);

  



  if (loading && productos.length === 0) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-xl text-gray-600">Cargando sistema POS...</p>
            </div>
          </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* CSS RESPONSIVE PARA MÓVILES Y DESKTOP */}
      <style>{`
        /* LAYOUT RESPONSIVE INLINE - FORZADO */
        .layout-inline-responsive {
          display: flex !important;
          flex-direction: column !important;
          gap: 24px !important;
          width: 100% !important;
        }
        
        @media (min-width: 1024px) {
          .layout-inline-responsive {
            flex-direction: row !important;
          }
          .columna-izquierda-inline {
            width: 60% !important;
            flex: 3 !important;
          }
          .columna-derecha-inline {
            width: 40% !important;
            flex: 2 !important;
          }
        }
        
        /* LAYOUT RESPONSIVE */
        .layout-forzado {
          display: flex !important;
          flex-direction: row !important;
          gap: 24px !important;
          width: 100% !important;
        }
        
        /* DESKTOP: 2 columnas */
        @media (min-width: 1024px) {
        .columna-izquierda {
          flex: 3 !important;
          min-width: 60% !important;
          max-width: 60% !important;
          width: 60% !important;
        }
        .columna-derecha {
          flex: 2 !important;
          min-width: 40% !important;
          max-width: 40% !important;
          width: 40% !important;
          }
        }
        
        /* TABLET: 2 columnas más compactas */
        @media (max-width: 1023px) and (min-width: 768px) {
          .layout-forzado {
            flex-direction: row !important;
            gap: 16px !important;
          }
          .columna-izquierda {
            flex: 2 !important;
            min-width: 65% !important;
            max-width: 65% !important;
          }
          .columna-derecha {
            flex: 1 !important;
            min-width: 35% !important;
            max-width: 35% !important;
          }
        }
        
        /* MÓVIL: 1 columna */
        @media (max-width: 767px) {
          .layout-forzado {
            flex-direction: column !important;
            gap: 16px !important;
            width: 100% !important;
          }
          .columna-izquierda {
            flex: none !important;
            min-width: 100% !important;
            max-width: 100% !important;
            width: 100% !important;
            order: 1 !important;
          }
          .columna-derecha {
            flex: none !important;
            min-width: 100% !important;
            max-width: 100% !important;
            width: 100% !important;
            order: 2 !important;
          }
        }
        
        /* HEADER RESPONSIVE */
        .ventas-header-ultra-compacto {
          padding: 12px 16px !important;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
          color: white !important;
          border-radius: 0 !important;
          margin-bottom: 0 !important;
        }
        
        @media (max-width: 767px) {
          .ventas-header-ultra-compacto {
            padding: 8px 12px !important;
          }
          .ventas-layout-horizontal {
            flex-direction: column !important;
            gap: 8px !important;
          }
          .ventas-lado-izquierdo,
          .ventas-lado-derecho {
            flex-direction: row !important;
            flex-wrap: wrap !important;
            gap: 8px !important;
            justify-content: space-between !important;
          }
        }
        
        /* TABLA RESPONSIVE */
        .tabla-carrito-mobile {
          display: none !important;
        }
        
        @media (max-width: 767px) {
          .tabla-carrito-desktop {
            display: none !important;
          }
          .tabla-carrito-mobile {
            display: block !important;
          }
        }
        
        /* LAYOUT MÓVIL FORZADO - ULTRA AGRESIVO */
        @media (max-width: 767px) {
          .layout-forzado {
            display: block !important;
            width: 100% !important;
            flex-direction: column !important;
            gap: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .columna-izquierda {
            display: block !important;
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
            flex: none !important;
            margin: 0 0 20px 0 !important;
            padding: 0 !important;
            order: 1 !important;
            float: none !important;
            clear: both !important;
          }
          .columna-derecha {
            display: block !important;
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
            flex: none !important;
            margin: 0 !important;
            padding: 0 !important;
            order: 2 !important;
            float: none !important;
            clear: both !important;
          }
        }
        
        /* FORZAR LAYOUT MÓVIL EN TODOS LOS ELEMENTOS */
        @media (max-width: 767px) {
          .layout-forzado * {
            max-width: 100% !important;
            box-sizing: border-box !important;
          }
          
          /* CONTENEDOR PRINCIPAL MÓVIL */
          .min-h-screen {
            padding: 0 !important;
            margin: 0 !important;
            width: 100% !important;
            overflow-x: hidden !important;
          }
          
          /* PADDING DEL CONTENEDOR */
          .p-6 {
            padding: 12px !important;
          }
          
          /* ESPACIADO ENTRE ELEMENTOS */
          .space-y-6 > * + * {
            margin-top: 16px !important;
          }
        }
        
        /* LAYOUT MÓVIL PARA TODOS LOS TAMAÑOS PEQUEÑOS */
        @media (max-width: 1023px) {
          .layout-forzado {
            display: block !important;
            width: 100% !important;
          }
          .columna-izquierda,
          .columna-derecha {
            display: block !important;
            width: 100% !important;
            margin-bottom: 16px !important;
          }
        }
        
        /* LAYOUT MÓVIL ESPECÍFICO PARA TABLETS */
        @media (max-width: 1023px) and (min-width: 768px) {
          .layout-forzado {
            display: block !important;
            width: 100% !important;
          }
          .columna-izquierda {
            display: block !important;
            width: 100% !important;
            margin-bottom: 20px !important;
          }
          .columna-derecha {
            display: block !important;
            width: 100% !important;
            margin-bottom: 0 !important;
          }
        }
        
        /* CAMPOS COMPACTOS RESPONSIVE */
        @media (max-width: 767px) {
          .ventas-campo-compacto {
            min-width: 80px !important;
            font-size: 14px !important;
            padding: 6px 8px !important;
          }
          .ventas-btn-azul {
            padding: 6px 12px !important;
            font-size: 12px !important;
          }
        }
        
        /* MODAL RESPONSIVE */
        .modal-overlay {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          z-index: 9999 !important;
          background-color: rgba(0, 0, 0, 0.8) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 16px !important;
        }
        
        .modal-content {
          position: relative !important;
          z-index: 10000 !important;
          background-color: white !important;
          border-radius: 1rem !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          width: 100% !important;
          max-width: 500px !important;
          max-height: 90vh !important;
          overflow-y: auto !important;
        }
        
        @media (max-width: 767px) {
          .modal-content {
            margin: 0 !important;
            border-radius: 0.5rem !important;
            max-height: 95vh !important;
          }
        }
      `}</style>
      
      {/* Header Ultra-Compacto - Sin espacio desperdiciado - ESTÉTICA MEJORADA */}
      <div className="ventas-header-ultra-compacto">
        <div className="ventas-layout-horizontal">
          {/* LADO IZQUIERDO - Todo en una sola línea horizontal ultra-compacta */}
          <div className="ventas-lado-izquierdo">
            <h1 className="ventas-header-ultra-compacto">
              <ShoppingBag className="w-4 h-4 text-blue-600" />
              Ventas
            </h1>
            
            {/* Indicador del número de ticket */}
            <div className="ventas-ticket-indicator">
              <span className="ventas-ticket-label">Ticket #</span>
              <span className="ventas-ticket-number">{numeroTicket}</span>
        </div>

            {/* Botón Scanner ultra-compacto */}
            <button
              onClick={iniciarScanner}
              disabled={scanning}
              className="ventas-btn-azul"
            >
              {scanning ? (
                <>
                  <div className="animate-spin rounded-full h-2 w-2 border-b border-white"></div>
                  Escaneando
                </>
              ) : (
                <>
                  <Camera className="w-3 h-3" />
                  Escanear
                </>
              )}
            </button>
            
            {/* Código ultra-compacto */}
            <div className="ventas-lado-izquierdo">
              <label className="ventas-label-compacto" style={{color: 'white', fontWeight: 'bold'}}>Código:</label>
              <input
                ref={inputCodigoRef}
                type="text"
                value={codigoBarras}
                onChange={(e) => setCodigoBarras(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && codigoBarras.trim()) {
                    console.log('⌨️ Enter presionado con código:', codigoBarras);
                    buscarYAgregarProducto(codigoBarras.trim());
                  } else if (e.key === 'Enter') {
                    console.log('❌ Enter presionado pero código vacío');
                  }
                }}
                placeholder="Código..."
                className="ventas-campo-compacto ventas-campo-codigo"
                autoFocus
              />
            </div>
            
            {/* Cantidad ultra-compacta */}
            <div className="ventas-lado-izquierdo">
              <label className="ventas-label-compacto" style={{color: 'white', fontWeight: 'bold'}}>Cant.:</label>
              <input
                type="number"
                min="1"
                value={cantidad}
                onChange={(e) => setCantidad(parseInt(e.target.value) || 1)}
                className="ventas-campo-compacto ventas-campo-cantidad"
              />
            </div>
            
            {/* Botón Buscar ultra-compacto */}
            <button
              onClick={() => {
                console.log('🔍 Botón Buscar clickeado con código:', codigoBarras);
                if (codigoBarras.trim()) {
                  buscarYAgregarProducto(codigoBarras);
                } else {
                  console.log('❌ Código vacío, no se puede buscar');
                }
              }}
              disabled={!codigoBarras.trim()}
              className="ventas-btn-azul"
            >
              <Search className="w-3 h-3" />
              Buscar
            </button>
            
          </div>
          
          {/* LADO DERECHO - Datos del comprobante ultra-compactos */}
          <div className="ventas-lado-derecho">
            <div className="ventas-lado-izquierdo">
              <label className="ventas-label-compacto" style={{color: 'white', fontWeight: 'bold'}}>Fecha:</label>
              <input
                type="text"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
                className="ventas-campo-compacto ventas-campo-fecha"
              />
        </div>

            <div className="ventas-lado-izquierdo">
              <label className="ventas-label-compacto" style={{color: 'white', fontWeight: 'bold'}}>Tipo:</label>
              <select
                value={tipoComprobante}
                onChange={(e) => setTipoComprobante(e.target.value)}
                className="ventas-campo-compacto ventas-campo-tipo"
              >
                <option>Ticket</option>
                <option>Factura A</option>
                <option>Factura B</option>
              </select>
            </div>
            
            <div className="ventas-lado-izquierdo">
              <label className="ventas-label-compacto" style={{color: 'white', fontWeight: 'bold'}}>Nro.:</label>
              <input
                type="text"
                value={numeroComprobante}
                onChange={(e) => setNumeroComprobante(e.target.value)}
                placeholder="Nro."
                className="w-12 px-1 py-0.5 text-xs border border-gray-300 rounded"
              />
            </div>
          </div>
        </div>
      </div>

            <div className="p-6 bg-white">
        {/* LAYOUT RESPONSIVE FORZADO CON CSS INLINE */}
        <div className="layout-inline-responsive" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          width: '100%'
        }}>
          
          {/* COLUMNA IZQUIERDA - CARRITO Y GESTIÓN */}
          <div className="columna-izquierda-inline" style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
          }}>

            {/* SECTOR CENTRAL - LISTA DE PRODUCTOS (CARRITO) */}
            <div className="bg-gray-50 rounded-lg shadow-sm border border-gray-200">
              <div className="p-6 border-b border-gray-200">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                  <ShoppingCart className="w-5 h-5 text-blue-600" />
                  Carrito de Compras
                </h2>
              </div>
              
        {/* TABLA DESKTOP */}
        <div className="overflow-x-auto tabla-carrito-desktop">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Codigo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descripcion</th>
                                             <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                                             <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Unitario</th>
                                             <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Importe</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
                    {carrito.map((item, index) => (
                      <tr 
                        key={item.id} 
                        className={`hover:bg-gray-50 cursor-pointer ${
                          itemSeleccionado === index ? 'bg-blue-50' : ''
                        }`}
                        onClick={() => setItemSeleccionado(index)}
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {index + 1}
                  </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {item.codigo_personalizado}
                  </td>
                        <td className="px-6 py-4 text-sm text-gray-900">
                          <div className="max-w-xs">
                            <div className="font-medium">{item.nombre}</div>
                            {item.marca && <div className="text-xs text-gray-500">{item.marca}</div>}
                          </div>
                  </td>
                                                                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center ventas-td-cantidad">
                           {editandoCantidad === index ? (
                             <input
                               type="number"
                               min="1"
                               value={valorTemporal}
                               onChange={(e) => setValorTemporal(e.target.value)}
                               onKeyPress={(e) => {
                                 if (e.key === 'Enter') {
                                   guardarCantidad(index);
                                 } else if (e.key === 'Escape') {
                                   cancelarEdicion();
                                 }
                               }}
                               onBlur={() => guardarCantidad(index)}
                               className="text-center border border-blue-300 rounded px-1 py-1 text-sm"
                               style={{ width: '2.5rem', maxWidth: '2.5rem' }}
                               autoFocus
                             />
                           ) : (
                             <span className="inline-block w-10 text-center">{item.cantidad}</span>
                           )}
                  </td>
                                                                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                           {editandoPrecio === index ? (
                             <input
                               type="number"
                               step="0.01"
                               min="0.01"
                               value={valorTemporal}
                               onChange={(e) => setValorTemporal(e.target.value)}
                               onKeyPress={(e) => {
                                 if (e.key === 'Enter') {
                                   guardarPrecio(index);
                                 } else if (e.key === 'Escape') {
                                   cancelarEdicion();
                                 }
                               }}
                               onBlur={() => guardarPrecio(index)}
                               className="text-center border border-green-300 rounded px-1 py-1 text-sm"
                               style={{ width: '4rem', maxWidth: '4rem' }}
                               autoFocus
                             />
                           ) : (
                             <span className="inline-block w-16 text-center">${item.precio_unitario.toFixed(2)}</span>
                           )}
                  </td>
                                                 <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 text-center">
                           ${(item.precio_unitario * item.cantidad).toFixed(2)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                           <div className="flex items-center gap-2">
                                                           {/* Botón para editar cantidad */}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (editandoCantidad === index) {
                                    guardarCantidad(index);
                                  } else {
                                    iniciarEdicionCantidad(index, item.cantidad);
                                  }
                                }}
                                className={`p-1 rounded hover:bg-blue-50 ${
                                  editandoCantidad === index 
                                    ? 'text-green-600 hover:text-green-800 bg-green-50' 
                                    : 'text-blue-600 hover:text-blue-800'
                                }`}
                                title={editandoCantidad === index ? "Guardar cantidad" : "Modificar cantidad"}
                              >
                                {editandoCantidad === index ? (
                                  <span className="text-xs">✓</span>
                                ) : (
                                  <Edit className="w-3 h-3" />
                                )}
                    </button>
                             
                                                           {/* Botón para editar precio */}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (editandoPrecio === index) {
                                    guardarPrecio(index);
                                  } else {
                                    iniciarEdicionPrecio(index, item.precio_unitario);
                                  }
                                }}
                                className={`p-1 rounded hover:bg-green-50 ${
                                  editandoPrecio === index 
                                    ? 'text-green-600 hover:text-green-800 bg-green-50' 
                                    : 'text-green-600 hover:text-green-800'
                                }`}
                                title={editandoPrecio === index ? "Guardar precio" : "Modificar precio"}
                              >
                                {editandoPrecio === index ? (
                                  <span className="text-xs">✓</span>
                                ) : (
                                  <DollarSign className="w-3 h-3" />
                                )}
                    </button>
                             
                             {/* Botón para borrar */}
                             <button
                               onClick={(e) => {
                                 e.stopPropagation();
                                 quitarItem(index);
                               }}
                               className="text-red-600 hover:text-red-900 p-1 rounded hover:bg-red-50"
                               title="Eliminar producto"
                             >
                               <Trash2 className="w-3 h-3" />
                             </button>
                           </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
                
                {carrito.length === 0 && (
                  <div className="text-center py-12">
                    <p className="text-gray-500">El carrito esta vacio</p>
                    <p className="text-sm text-gray-400">Escanea productos para comenzar</p>
                  </div>
                )}
        </div>

        {/* TABLA MÓVIL */}
        <div className="tabla-carrito-mobile">
          {carrito.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">El carrito esta vacio</p>
              <p className="text-sm text-gray-400">Escanea productos para comenzar</p>
            </div>
          ) : (
            <div className="space-y-3">
              {carrito.map((item, index) => (
                <div 
                  key={item.id}
                  className={`bg-white border rounded-lg p-4 ${
                    itemSeleccionado === index ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
                  }`}
                  onClick={() => setItemSeleccionado(index)}
                >
                  {/* Header del item */}
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-900 text-sm">{item.nombre}</h4>
                      {item.marca && <p className="text-xs text-gray-500">{item.marca}</p>}
                      <p className="text-xs text-gray-600">Código: {item.codigo_personalizado}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-semibold text-gray-900">${(item.precio_unitario * item.cantidad).toFixed(2)}</p>
                    </div>
                  </div>
                  
                  {/* Detalles del item */}
                  <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
                    <div>
                      <span className="font-medium">Cantidad:</span>
                      {editandoCantidad === index ? (
                        <div className="flex items-center gap-1 mt-1">
                          <input
                            type="number"
                            min="1"
                            value={valorTemporal}
                            onChange={(e) => setValorTemporal(parseInt(e.target.value) || 1)}
                            className="w-16 px-2 py-1 text-xs border border-gray-300 rounded"
                            autoFocus
                          />
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              guardarCantidad(index);
                            }}
                            className="text-green-600 hover:text-green-800"
                          >
                            ✓
                          </button>
                        </div>
                      ) : (
                        <span className="ml-1">{item.cantidad}</span>
                      )}
                    </div>
                    <div>
                      <span className="font-medium">Unitario:</span>
                      {editandoPrecio === index ? (
                        <div className="flex items-center gap-1 mt-1">
                          <input
                            type="number"
                            step="0.01"
                            min="0"
                            value={valorTemporal}
                            onChange={(e) => setValorTemporal(parseFloat(e.target.value) || 0)}
                            className="w-20 px-2 py-1 text-xs border border-gray-300 rounded"
                            autoFocus
                          />
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              guardarPrecio(index);
                            }}
                            className="text-green-600 hover:text-green-800"
                          >
                            ✓
                          </button>
                        </div>
                      ) : (
                        <span className="ml-1">${item.precio_unitario.toFixed(2)}</span>
                      )}
                    </div>
                  </div>
                  
                  {/* Botones de acción */}
                  <div className="flex justify-end gap-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (editandoCantidad === index) {
                          guardarCantidad(index);
                        } else {
                          iniciarEdicionCantidad(index, item.cantidad);
                        }
                      }}
                      className={`px-3 py-1 text-xs rounded ${
                        editandoCantidad === index 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-blue-100 text-blue-700'
                      }`}
                    >
                      {editandoCantidad === index ? 'Guardar' : 'Editar Cant.'}
                    </button>
                    
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (editandoPrecio === index) {
                          guardarPrecio(index);
                        } else {
                          iniciarEdicionPrecio(index, item.precio_unitario);
                        }
                      }}
                      className={`px-3 py-1 text-xs rounded ${
                        editandoPrecio === index 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-green-100 text-green-700'
                      }`}
                    >
                      {editandoPrecio === index ? 'Guardar' : 'Editar Precio'}
                    </button>
                    
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        quitarItem(index);
                      }}
                      className="px-3 py-1 text-xs rounded bg-red-100 text-red-700"
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
                  </div>
                )}
        </div>
      </div>

            {/* SECTOR INFERIOR - GESTION DE ITEMS */}
            <div className="bg-gray-50 rounded-lg shadow-sm p-6 border border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Gestion de Items</h3>
              
                            <div className="ventas-gestion-items">
                <button
                  onClick={() => {
                    console.log('🔍 Botón Descuento clickeado');
                    console.log('Carrito length:', carrito.length);
                    if (carrito.length > 0) {
                      console.log('🚨 USANDO MODAL DIRECTO 🚨');
                      mostrarModalDescuentoDirecto();
                    } else {
                      console.log('Carrito vacío, no se puede aplicar descuento');
                    }
                  }}
                  disabled={false}
                  className="ventas-btn-descuento"
                  title={carrito.length === 0 ? "Agrega productos al carrito" : "Aplicar descuento"}
                >
                  <Percent className="w-4 h-4" />
                  Descuento
                </button>
                
                <button
                  onClick={() => {
                    console.log('🔍 Botón Recargo clickeado');
                    console.log('Carrito length:', carrito.length);
                    if (carrito.length > 0) {
                      console.log('🚨 USANDO MODAL RECARGO DIRECTO 🚨');
                      mostrarModalRecargoDirecto();
                    } else {
                      console.log('Carrito vacío, no se puede aplicar recargo');
                    }
                  }}
                  disabled={carrito.length === 0}
                  className="ventas-btn-recargo"
                  title={carrito.length === 0 ? "Agrega productos al carrito" : "Aplicar recargo"}
                >
                  <Plus className="w-4 h-4" />
                  Recargo
                </button>

                {itemSeleccionado !== null && (
                  <button
                    onClick={limpiarSeleccion}
                    className="ventas-btn-limpiar"
                    title="Limpiar selección"
                  >
                    <X className="w-4 h-4" />
                    Limpiar
                  </button>
                )}
                
                                 {/* Botón de información */}
                 <button
                                    onClick={() => {
                   console.log('🔍 Botón Info clickeado - VERSIÓN ACTUALIZADA');
                   console.log('Estado actual mostrarPopupInfo:', mostrarPopupInfo);
                   console.log('🔄 Cambiando estado a true...');
                   setMostrarPopupInfo(true);
                   console.log('✅ Estado actualizado a true - POPUP DEBERÍA APARECER');
                   console.log('🎯 Si no aparece, hay un problema de CSS o renderizado');
                   console.log('🚀 POPUP IMPLEMENTADO CORRECTAMENTE - VERIFICAR NAVEGADOR');
                   
                   // Verificar después de un pequeño delay
                   setTimeout(() => {
                     console.log('🔍 [DEBUG] Estado después de 100ms:', mostrarPopupInfo);
                   }, 100);
                 }}
                   className="ventas-btn-azul"
                   title="Información del sistema"
                 >
                   <Info className="w-4 h-4" />
                   Info
                 </button>
              </div>
            </div>
          </div>

          {/* COLUMNA DERECHA - DATOS DEL COMPROBANTE Y RESUMEN */}
          <div className="columna-derecha-inline" style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
          }}>
             
             {/* 1. DATOS DEL COMPROBANTE - RESPONSIVE */}
             <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm">
               <h3 className="text-lg font-semibold text-gray-900 mb-2">Datos del comprobante</h3>
               <h4 className="text-sm font-medium text-gray-700 mb-2">Observaciones</h4>
               <textarea
                 value={observaciones}
                 onChange={(e) => setObservaciones(e.target.value)}
                 placeholder="Observaciones de la venta"
                 rows="3"
                 className="w-full p-3 text-sm border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
               />
             </div>

             {/* 2. RESUMEN DE VENTA - RESPONSIVE */}
             <div className="bg-white rounded-lg p-4 border-2 border-blue-500 shadow-lg">
               <h3 className="text-sm font-bold text-center text-blue-600 mb-4 pb-2 border-b-2 border-blue-500">
                 RESUMEN DE VENTA
               </h3>
               
               <div className="space-y-2">
                 <div className="flex justify-between items-center">
                   <span className="text-xs font-bold text-gray-700">Subtotal:</span>
                   <span className="text-xs font-bold text-blue-600">${calcularTotales().subtotal.toFixed(2)}</span>
                 </div>
                 
                 {descuentoTotal > 0 && (
                   <div className="flex justify-between items-center">
                     <span className="text-xs font-bold text-gray-700">Descuento:</span>
                     <span className="text-xs font-bold text-green-600">-${descuentoTotal.toFixed(2)}</span>
                   </div>
                 )}
                 
                 {recargoTotal > 0 && (
                   <div className="flex justify-between items-center">
                     <span className="text-xs font-bold text-gray-700">Recargo:</span>
                     <span className="text-xs font-bold text-red-600">+${recargoTotal.toFixed(2)}</span>
                   </div>
                 )}
                 
                 <div className="border-t-2 border-blue-500 pt-2 mt-2">
                   <div className="flex justify-between items-center">
                     <span className="text-sm font-bold text-blue-600">TOTAL:</span>
                     <span className="text-sm font-bold text-blue-600">${calcularTotales().total.toFixed(2)}</span>
                   </div>
                 </div>
               </div>
               
               {/* Botón principal COBRAR */}
               <div className="mt-4">
                 <button
                   onClick={() => {
                     console.log('🔍 Botón COBRAR clickeado');
                     console.log('Carrito length:', carrito.length);
                     console.log('Llamando a abrirModalPago');
                     abrirModalPago();
                   }}
                   disabled={carrito.length === 0}
                   className={`w-full py-3 px-4 rounded-lg font-bold text-sm border-none transition-all duration-200 ${
                     carrito.length === 0 
                       ? 'bg-gray-400 text-gray-600 cursor-not-allowed' 
                       : 'bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800'
                   }`}
                 >
                   💰 COBRAR
                 </button>
                 
               </div>
             </div>


                   </div>
        </div>
      </div>

      {/* MODAL DE PAGOS PARCIALES - USANDO PORTAL */}
      {console.log('🔍 Renderizando modal - mostrarModalPago:', mostrarModalPago)}
      {mostrarModalPago && createPortal(
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 0, 0, 0.9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 999999,
          width: '100vw',
          height: '100vh',
          border: '5px solid yellow'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '0.5rem',
            padding: '2rem',
            width: '90%',
            maxWidth: '40rem',
            margin: '0 1rem',
            maxHeight: '90vh',
            overflowY: 'auto',
            border: '3px solid blue',
            fontSize: '18px',
            fontWeight: 'bold'
          }}>
            
            {/* Header del modal */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem' }}>
              <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                💰 Pagos Parciales
              </h2>
              <button
                onClick={() => {
                  setMostrarModalPago(false);
                  limpiarPagosParciales();
                }}
                style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#9ca3af', cursor: 'pointer', border: 'none', background: 'none' }}
              >
                ✕
              </button>
            </div>

            {/* Resumen de la Venta */}
            <div style={{ backgroundColor: '#eff6ff', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #bfdbfe', marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.75rem', marginTop: 0 }}>
                📊 Resumen de la Venta
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                  <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#374151' }}>Subtotal:</span>
                  <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#111827' }}>${subtotal.toFixed(2)}</span>
                </div>
                {descuentoTotal > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                    <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#374151' }}>Descuento:</span>
                    <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#dc2626' }}>-${descuentoTotal.toFixed(2)}</span>
                  </div>
                )}
                {recargoTotal > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                    <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#374151' }}>Recargo:</span>
                    <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#16a34a' }}>+${recargoTotal.toFixed(2)}</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem', backgroundColor: '#2563eb', borderRadius: '0.25rem', color: 'white' }}>
                  <span style={{ fontSize: '1rem', fontWeight: '600' }}>Total Final:</span>
                  <span style={{ fontSize: '1.125rem', fontWeight: 'bold' }}>${total.toFixed(2)}</span>
                </div>
              </div>
            </div>

            {/* Lista de Pagos Parciales */}
            {pagosParciales.length > 0 && (
              <div style={{ backgroundColor: '#f0fdf4', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #bbf7d0', marginBottom: '1rem' }}>
                <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#166534', marginBottom: '0.75rem', marginTop: 0 }}>
                  💳 Pagos Registrados
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  {pagosParciales.map((pago, index) => (
                    <div key={pago.id} style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center', 
                      padding: '0.75rem', 
                      backgroundColor: 'white', 
                      borderRadius: '0.25rem',
                      border: '1px solid #d1fae5'
                    }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#111827' }}>
                          {pago.metodo_pago.charAt(0).toUpperCase() + pago.metodo_pago.slice(1).replace('_', ' ')}
                        </span>
                        <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                          {pago.referencia && `Ref: ${pago.referencia}`}
                          {pago.observaciones && ` - ${pago.observaciones}`}
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <span style={{ fontSize: '1rem', fontWeight: 'bold', color: '#059669' }}>
                          ${pago.monto.toFixed(2)}
                        </span>
                        <button
                          onClick={() => eliminarPagoParcial(pago.id)}
                          style={{
                            padding: '0.25rem',
                            backgroundColor: '#fef2f2',
                            color: '#dc2626',
                            border: '1px solid #fecaca',
                            borderRadius: '0.25rem',
                            cursor: 'pointer',
                            fontSize: '0.75rem'
                          }}
                          title="Eliminar pago"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  ))}
                  
                  {/* Resumen de pagos */}
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '0.75rem', 
                    backgroundColor: '#dcfce7', 
                    borderRadius: '0.25rem',
                    border: '1px solid #bbf7d0',
                    marginTop: '0.5rem'
                  }}>
                    <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#166534' }}>
                      Total Pagado:
                    </span>
                    <span style={{ fontSize: '1rem', fontWeight: 'bold', color: '#059669' }}>
                      ${totalPagosParciales.toFixed(2)}
                    </span>
                  </div>
                  
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '0.75rem', 
                    backgroundColor: saldoPendiente > 0 ? '#fef3c7' : '#dcfce7', 
                    borderRadius: '0.25rem',
                    border: `1px solid ${saldoPendiente > 0 ? '#fbbf24' : '#bbf7d0'}`
                  }}>
                    <span style={{ fontSize: '0.875rem', fontWeight: '600', color: saldoPendiente > 0 ? '#92400e' : '#166534' }}>
                      Saldo Pendiente:
                    </span>
                    <span style={{ fontSize: '1rem', fontWeight: 'bold', color: saldoPendiente > 0 ? '#d97706' : '#059669' }}>
                      ${saldoPendiente.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Formulario para agregar pago */}
            {saldoPendiente > 0 && (
              <div style={{ backgroundColor: '#fef3c7', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #fbbf24', marginBottom: '1rem' }}>
                <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#92400e', marginBottom: '0.75rem', marginTop: 0 }}>
                  ➕ Agregar Pago
                </h3>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {/* Método de pago */}
                  <div>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>
                      Método de Pago:
                    </label>
                    <select
                      value={metodoPagoActual}
                      onChange={(e) => setMetodoPagoActual(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '0.5rem',
                        fontSize: '0.875rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem'
                      }}
                    >
                      <option value="efectivo">Efectivo</option>
                      <option value="tarjeta_debito">Tarjeta de Débito</option>
                      <option value="tarjeta_credito">Tarjeta de Crédito</option>
                      <option value="transferencia">Transferencia</option>
                      <option value="mercado_pago">Mercado Pago</option>
                    </select>
                  </div>
                  
                  {/* Monto */}
                  <div>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>
                      Monto (Máximo: ${saldoPendiente.toFixed(2)}):
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0.01"
                      max={saldoPendiente}
                      value={montoPagoActual}
                      onChange={(e) => setMontoPagoActual(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '0.5rem',
                        fontSize: '0.875rem',
                        border: '2px solid #f59e0b',
                        borderRadius: '0.375rem',
                        textAlign: 'center',
                        fontWeight: '600'
                      }}
                      placeholder="0.00"
                    />
                  </div>
                  
                  {/* Referencia (opcional) */}
                  <div>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>
                      Referencia (opcional):
                    </label>
                    <input
                      type="text"
                      value={referenciaPago}
                      onChange={(e) => setReferenciaPago(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '0.5rem',
                        fontSize: '0.875rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem'
                      }}
                      placeholder="Número de operación, etc."
                    />
                  </div>
                  
                  {/* Observaciones (opcional) */}
                  <div>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>
                      Observaciones (opcional):
                    </label>
                    <input
                      type="text"
                      value={observacionesPago}
                      onChange={(e) => setObservacionesPago(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '0.5rem',
                        fontSize: '0.875rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem'
                      }}
                      placeholder="Notas adicionales"
                    />
                  </div>
                  
                  {/* Botón agregar */}
                  <button
                    onClick={agregarPagoParcial}
                    disabled={!montoPagoActual || parseFloat(montoPagoActual) <= 0}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      backgroundColor: !montoPagoActual || parseFloat(montoPagoActual) <= 0 ? '#9ca3af' : '#f59e0b',
                      color: 'white',
                      borderRadius: '0.375rem',
                      fontWeight: '600',
                      border: 'none',
                      cursor: !montoPagoActual || parseFloat(montoPagoActual) <= 0 ? 'not-allowed' : 'pointer',
                      fontSize: '0.875rem',
                      opacity: !montoPagoActual || parseFloat(montoPagoActual) <= 0 ? '0.5' : '1'
                    }}
                  >
                    ➕ Agregar Pago
                  </button>
                </div>
              </div>
            )}

            {/* Botones de acción */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #e5e7eb' }}>
              <button
                onClick={() => {
                  setMostrarModalPago(false);
                  limpiarPagosParciales();
                }}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: '#6b7280',
                  color: 'white',
                  borderRadius: '0.375rem',
                  fontWeight: '600',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '0.875rem'
                }}
              >
                ❌ Cancelar
              </button>
              
              {pagosParciales.length > 0 && (
                <button
                  onClick={limpiarPagosParciales}
                  style={{
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#f59e0b',
                    color: 'white',
                    borderRadius: '0.375rem',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '0.875rem'
                  }}
                >
                  🗑️ Limpiar Todo
                </button>
              )}
              
              <button
                onClick={finalizarVenta}
                disabled={procesandoVenta || saldoPendiente > 0.01}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: !procesandoVenta && saldoPendiente <= 0.01 ? '#2563eb' : '#9ca3af',
                  color: 'white',
                  borderRadius: '0.375rem',
                  fontWeight: '600',
                  border: 'none',
                  cursor: !procesandoVenta && saldoPendiente <= 0.01 ? 'pointer' : 'not-allowed',
                  fontSize: '0.875rem',
                  opacity: !procesandoVenta && saldoPendiente <= 0.01 ? '1' : '0.5'
                }}
              >
                {procesandoVenta ? '⏳ Procesando...' : '✅ Finalizar Venta'}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* MODAL DE DESCUENTO - VERSIÓN SIMPLE Y FUNCIONAL */}
      {mostrarModalDescuento && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 999999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '500px',
            padding: '2rem',
            borderRadius: '8px',
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
          }}>
            <h2 style={{ marginBottom: '1.5rem', color: '#333' }}>
              💰 Aplicar Descuento
              </h2>
            
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                Tipo de descuento:
              </label>
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <input
                    type="radio"
                    name="tipoDescuento"
                    value="importe"
                    checked={tipoDescuento === 'importe'}
                    onChange={(e) => setTipoDescuento(e.target.value)}
                  />
                  <span>Importe fijo ($)</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <input
                    type="radio"
                    name="tipoDescuento"
                    value="porcentaje"
                    checked={tipoDescuento === 'porcentaje'}
                    onChange={(e) => setTipoDescuento(e.target.value)}
                  />
                  <span>Porcentaje (%)</span>
                </label>
                </div>
              </div>
              
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                {tipoDescuento === 'importe' ? 'Importe del descuento:' : 'Porcentaje del descuento:'}
                  </label>
                  <input
                    type="number"
                    value={valorDescuento}
                    onChange={(e) => setValorDescuento(e.target.value)}
                placeholder={tipoDescuento === 'importe' ? '0.00' : '0'}
                    style={{
                      padding: '0.75rem',
                  border: '2px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1.1rem',
                      textAlign: 'center',
                  width: '200px'
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    aplicarDescuento();
                  }
                }}
              />
              </div>
              
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button
                onClick={() => {
                  setMostrarModalDescuento(false);
                  setValorDescuento('');
                  setTipoDescuento('importe');
                }}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={aplicarDescuento}
                disabled={!valorDescuento || parseFloat(valorDescuento) <= 0}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: valorDescuento && parseFloat(valorDescuento) > 0 ? '#28a745' : '#ccc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: valorDescuento && parseFloat(valorDescuento) > 0 ? 'pointer' : 'not-allowed'
                }}
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* POPUP ELEGANTE DE RECARGO - Estilo similar al scanner de precio */}
      {mostrarModalRecargo && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '0.5rem',
            padding: '1.5rem',
            width: '100%',
            maxWidth: '48rem',
            margin: '0 1rem',
            textAlign: 'center'
          }}>
            
            {/* Header del popup */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.75rem' }}>
              <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                📈 Aplicar Recargo al Total de la Venta
              </h2>
              <button
                onClick={() => {
                  setMostrarModalRecargo(false);
                  setValorRecargo('');
                  setTipoRecargo('importe');
                }}
                style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#9ca3af', cursor: 'pointer', border: 'none', background: 'none' }}
              >
                ✕
              </button>
    </div>

            {/* Contenido del popup */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              
              {/* Selector de tipo de recargo */}
              <div style={{ backgroundColor: '#fef3c7', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #fbbf24' }}>
                <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#92400e', marginBottom: '0.75rem', marginTop: 0 }}>
                  🎯 Selecciona el Tipo de Recargo
                </h3>
                <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
                  <button
                    onClick={() => setTipoRecargo('importe')}
                    style={{
                      padding: '0.75rem 1rem',
                      borderRadius: '0.5rem',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      backgroundColor: tipoRecargo === 'importe' ? '#f59e0b' : '#fef3c7',
                      color: tipoRecargo === 'importe' ? 'white' : '#92400e',
                      transition: 'all 0.2s'
                    }}
                  >
                    💰 Importe Fijo
                  </button>
                  <button
                    onClick={() => setTipoRecargo('porcentaje')}
                    style={{
                      padding: '0.75rem 1rem',
                      borderRadius: '0.5rem',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      backgroundColor: tipoRecargo === 'porcentaje' ? '#f59e0b' : '#fef3c7',
                      color: tipoRecargo === 'porcentaje' ? 'white' : '#92400e',
                      transition: 'all 0.2s'
                    }}
                  >
                    📊 Porcentaje
                  </button>
                </div>
              </div>
              
              {/* Campo de valor */}
              <div style={{ backgroundColor: '#f0fdf4', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #bbf7d0' }}>
                <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#166534', marginBottom: '0.75rem', marginTop: 0 }}>
                  📝 Ingresa el Valor del Recargo
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: '#166534' }}>
                    {tipoRecargo === 'importe' ? '💰 Valor en Pesos ($)' : '📊 Porcentaje (%)'}
                  </label>
                  <input
                    type="number"
                    step={tipoRecargo === 'importe' ? '0.01' : '0.1'}
                    min="0"
                    max={tipoRecargo === 'porcentaje' ? '100' : ''}
                    value={valorRecargo}
                    onChange={(e) => setValorRecargo(e.target.value)}
                    style={{
                      width: '100%',
                      maxWidth: '250px',
                      padding: '0.75rem',
                      fontSize: '1rem',
                      border: '2px solid #16a34a',
                      borderRadius: '0.5rem',
                      textAlign: 'center',
                      fontWeight: '600'
                    }}
                    placeholder={tipoRecargo === 'importe' ? '0.00' : '0.0'}
                  />
                </div>
              </div>
              
              {/* Información adicional */}
              <div style={{ backgroundColor: '#eff6ff', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #bfdbfe' }}>
                <h3 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem', marginTop: 0 }}>
                  ℹ️ Información Importante
                </h3>
                <p style={{ fontSize: '0.75rem', color: '#1e40af', margin: 0, lineHeight: '1.4' }}>
                  • El recargo se aplicará al <strong>TOTAL de la venta</strong><br/>
                  • No afecta los precios individuales de los productos<br/>
                  • Se puede modificar o eliminar antes de finalizar la venta
                </p>
              </div>
            </div>

            {/* Botones de acción */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid #e5e7eb' }}>
              <button
                onClick={() => {
                  setMostrarModalRecargo(false);
                  setValorRecargo('');
                  setTipoRecargo('importe');
                }}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: '#6b7280',
                  color: 'white',
                  borderRadius: '0.5rem',
                  fontWeight: '600',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '1rem'
                }}
              >
                ❌ Cancelar
              </button>
              <button
                onClick={aplicarRecargo}
                disabled={!valorRecargo || parseFloat(valorRecargo) <= 0}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: !valorRecargo || parseFloat(valorRecargo) <= 0 ? '#9ca3af' : '#f59e0b',
                  color: 'white',
                  borderRadius: '0.5rem',
                  fontWeight: '600',
                  border: 'none',
                  cursor: !valorRecargo || parseFloat(valorRecargo) <= 0 ? 'not-allowed' : 'pointer',
                  fontSize: '1rem',
                  opacity: !valorRecargo || parseFloat(valorRecargo) <= 0 ? '0.5' : '1'
                }}
              >
                ✅ Aplicar Recargo
              </button>
            </div>
          </div>
        </div>
      )}

             {/* Modal de Cambiar Cantidad - CON FONDO BLANCO FORZADO */}
       {mostrarModalCantidad && itemSeleccionado !== null && (
         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
           <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4" style={{ backgroundColor: 'white !important' }}>
             <h3 className="text-lg font-semibold text-gray-900 mb-4">Cambiar Cantidad</h3>
             
             <div className="mb-4">
               <label className="block text-sm font-medium text-gray-700 mb-2">Nueva Cantidad</label>
               <input
                 type="number"
                 min="1"
                 defaultValue={carrito[itemSeleccionado]?.cantidad || 1}
                 id="nuevaCantidad"
                 className="w-full px-3 py-2 border border-gray-300 rounded-lg"
               />
             </div>
             
             <div className="flex gap-3">
               <button
                 onClick={() => setMostrarModalCantidad(false)}
                 className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
               >
                 Cancelar
               </button>
               <button
                 onClick={() => {
                   const nuevaCantidad = parseInt(document.getElementById('nuevaCantidad').value) || 1;
                   cambiarCantidad(nuevaCantidad);
                 }}
                 className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
               >
                 Cambiar
               </button>
             </div>
           </div>
         </div>
       )}

       {/* Popup de cámara para scanner */}
       {showCamera && (
         <div className="camera-popup">
           <div className="camera-header">
             <h3>📸 {scanning ? 'Scanner Automático' : 'Cámara'}</h3>
             <button onClick={cerrarCamara} className="camera-close">✕</button>
             </div>
             
                       <video 
               ref={videoRef} 
              autoPlay 
              playsInline 
              muted 
              className="camera-video" 
               style={{
                filter: modoBN ? 'grayscale(100%) contrast(150%) brightness(120%)' : 'none',
                WebkitFilter: modoBN ? 'grayscale(100%) contrast(150%) brightness(120%)' : 'none'
               }}
             />
             
             {scanning ? (
                             <div className="scanning-info">
                 <p>📱 Apunta la cámara al código de barras. Se detectará automáticamente.</p>
                 <div className="scanning-indicator">
                   <div className="scanning-dot"></div>
                   <div className="scanning-dot"></div>
                   <div className="scanning-dot"></div>
                 </div>
               </div>
             ) : (
                             <div className="scanning-info" style={{ background: '#fef3c7', borderColor: '#f59e0b', color: '#92400e' }}>
                 <p>⏳ Esperando 3 segundos para la siguiente captura...</p>
                 <p style={{ fontSize: '12px', marginTop: '10px' }}>
                   <strong>Estado:</strong> Pausado temporalmente
                 </p>
                 {ultimoCodigoProcesado && (
                   <p style={{ fontSize: '11px', marginTop: '8px', fontStyle: 'italic' }}>
                     Último código: {ultimoCodigoProcesado}
                   </p>
                 )}
               </div>
             )}
             
                         <div className="camera-controls">
             <button 
                 onClick={() => setModoBN(!modoBN)} 
                 className="btn btn-secondary"
               style={{
                   backgroundColor: modoBN ? '#1f2937' : '#6b7280',
                 color: 'white',
                   marginRight: '10px'
                 }}
               >
                 {modoBN ? '🎨 Modo Color' : '⚫ Modo B&N'}
               </button>
               <button onClick={cerrarCamara} className="btn btn-secondary">
               Terminar Escaneo
             </button>
           </div>
         </div>
       )}

       {/* Mensaje de error del scanner */}
       {error && (
         <div className="fixed top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded z-50">
           <strong>Error del Scanner:</strong> {error}
         </div>
       )}

       {/* POPUP INFORMATIVO COMPLETO DEL SISTEMA */}
       {mostrarPopupInfo && (
         <div style={{
           position: 'fixed',
           top: 0,
           left: 0,
           right: 0,
           bottom: 0,
           backgroundColor: 'rgba(0, 0, 0, 0.6)',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           zIndex: 99999
         }}>
           <div style={{
             backgroundColor: 'white',
             borderRadius: '0.5rem',
             padding: '2rem',
             width: '100%',
             maxWidth: '64rem',
             margin: '0 1rem',
             maxHeight: '90vh',
             overflowY: 'auto',
             boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
           }}>
             
             {/* Header del popup */}
             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '1rem' }}>
               <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                 📚 Sistema de Descuentos y Recargos
               </h2>
               <button
                 onClick={() => setMostrarPopupInfo(false)}
                 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#9ca3af', cursor: 'pointer', border: 'none', background: 'none' }}
               >
                 ✕
               </button>
             </div>

             {/* Contenido del popup */}
             <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
               
               {/* 1. DESCRIPCIÓN GENERAL */}
               <div style={{ backgroundColor: '#eff6ff', padding: '1.5rem', borderRadius: '0.5rem', border: '1px solid #bfdbfe' }}>
                 <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.75rem', marginTop: 0 }}>
                   🎯 ¿Cómo Funciona el Sistema?
                 </h3>
                 <p style={{ color: '#1e40af', marginBottom: '0.75rem', marginTop: 0 }}>
                   Este sistema permite aplicar <strong>descuentos y recargos al TOTAL de la venta</strong>, 
                   no a productos individuales. Los cambios se reflejan automáticamente en el resumen final.
                 </p>
                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginTop: '1rem' }}>
                   <div style={{ backgroundColor: 'white', padding: '1rem', borderRadius: '0.25rem', border: '1px solid #93c5fd' }}>
                     <h4 style={{ fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem', marginTop: 0 }}>💰 Descuentos</h4>
                     <ul style={{ fontSize: '0.875rem', color: '#1e40af', margin: 0, paddingLeft: '1rem' }}>
                       <li>• <strong>Importe Fijo:</strong> Resta una cantidad específica</li>
                       <li>• <strong>Porcentaje:</strong> Resta un % del subtotal</li>
                       <li>• Se aplican al total de la venta</li>
                     </ul>
                   </div>
                   <div style={{ backgroundColor: 'white', padding: '1rem', borderRadius: '0.25rem', border: '1px solid #93c5fd' }}>
                     <h4 style={{ fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem', marginTop: 0 }}>📈 Recargos</h4>
                     <ul style={{ fontSize: '0.875rem', color: '#1e40af', margin: 0, paddingLeft: '1rem' }}>
                       <li>• <strong>Importe Fijo:</strong> Suma una cantidad específica</li>
                       <li>• <strong>Porcentaje:</strong> Suma un % del subtotal</li>
                       <li>• Se aplican al total de la venta</li>
                     </ul>
                   </div>
                 </div>
               </div>

               {/* 2. PASOS PARA USAR */}
               <div style={{ backgroundColor: '#f0fdf4', padding: '1.5rem', borderRadius: '0.5rem', border: '1px solid #bbf7d0' }}>
                 <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#166534', marginBottom: '0.75rem', marginTop: 0 }}>
                   📋 Pasos para Aplicar
                 </h3>
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                     <span style={{ backgroundColor: '#16a34a', color: 'white', borderRadius: '50%', width: '1.5rem', height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', fontWeight: 'bold' }}>1</span>
                     <p style={{ color: '#166534', margin: 0 }}>Agrega productos al carrito de compras</p>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                     <span style={{ backgroundColor: '#16a34a', color: 'white', borderRadius: '50%', width: '1.5rem', height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', fontWeight: 'bold' }}>2</span>
                     <p style={{ color: '#166534', margin: 0 }}>Haz clic en "Descuento" o "Recargo" según necesites</p>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                     <span style={{ backgroundColor: '#16a34a', color: 'white', borderRadius: '50%', width: '1.5rem', height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', fontWeight: 'bold' }}>3</span>
                     <p style={{ color: '#166534', margin: 0 }}>Selecciona el tipo: "Importe Fijo" o "Porcentaje"</p>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                     <span style={{ backgroundColor: '#16a34a', color: 'white', borderRadius: '50%', width: '1.5rem', height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', fontWeight: 'bold' }}>4</span>
                     <p style={{ color: '#166534', margin: 0 }}>Ingresa el valor del descuento o recargo</p>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                     <span style={{ backgroundColor: '#16a34a', color: 'white', borderRadius: '50%', width: '1.5rem', height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', fontWeight: 'bold' }}>5</span>
                     <p style={{ color: '#166534', margin: 0 }}>Haz clic en "Aplicar" para confirmar</p>
                   </div>
                 </div>
               </div>

               {/* 3. EJEMPLOS PRÁCTICOS */}
               <div style={{ backgroundColor: '#faf5ff', padding: '1.5rem', borderRadius: '0.5rem', border: '1px solid #ddd6fe' }}>
                 <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#7c3aed', marginBottom: '0.75rem', marginTop: 0 }}>
                   💡 Ejemplos Prácticos
                 </h3>
                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
                   <div style={{ backgroundColor: 'white', padding: '1rem', borderRadius: '0.25rem', border: '1px solid #c4b5fd' }}>
                     <h4 style={{ fontWeight: '600', color: '#7c3aed', marginBottom: '0.5rem', marginTop: 0 }}>🏷️ Descuento por Cliente Frecuente</h4>
                     <p style={{ fontSize: '0.875rem', color: '#6b21a8', marginBottom: '0.5rem', marginTop: 0 }}>
                       <strong>Subtotal:</strong> $1000.00<br/>
                       <strong>Descuento:</strong> 10% (Porcentaje)<br/>
                       <strong>Resultado:</strong> -$100.00<br/>
                       <strong>Total Final:</strong> $900.00
                     </p>
                   </div>
                   <div style={{ backgroundColor: 'white', padding: '1rem', borderRadius: '0.25rem', border: '1px solid #c4b5fd' }}>
                     <h4 style={{ fontWeight: '600', color: '#7c3aed', marginBottom: '0.5rem', marginTop: 0 }}>🚚 Recargo por Entrega</h4>
                     <p style={{ fontSize: '0.875rem', color: '#6b21a8', marginBottom: '0.5rem', marginTop: 0 }}>
                       <strong>Subtotal:</strong> $500.00<br/>
                       <strong>Recargo:</strong> $50.00 (Importe Fijo)<br/>
                       <strong>Resultado:</strong> +$50.00<br/>
                       <strong>Total Final:</strong> $550.00
                     </p>
                   </div>
                 </div>
               </div>

               {/* 4. FUNCIONES ADICIONALES */}
               <div style={{ backgroundColor: '#fff7ed', padding: '1.5rem', borderRadius: '0.5rem', border: '1px solid #fed7aa' }}>
                 <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#ea580c', marginBottom: '0.75rem', marginTop: 0 }}>
                   🔧 Funciones Adicionales
                 </h3>
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                   <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                     <span style={{ color: '#ea580c', fontSize: '1.25rem' }}>🧹</span>
                     <div>
                       <p style={{ fontWeight: '600', color: '#ea580c', margin: 0 }}>Botón Limpiar</p>
                       <p style={{ fontSize: '0.875rem', color: '#c2410c', margin: 0 }}>Elimina todos los descuentos y recargos aplicados</p>
                     </div>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                     <span style={{ color: '#ea580c', fontSize: '1.25rem' }}>📊</span>
                     <div>
                       <p style={{ fontWeight: '600', color: '#ea580c', margin: 0 }}>Resumen Automático</p>
                       <p style={{ fontSize: '0.875rem', color: '#c2410c', margin: 0 }}>El resumen se actualiza automáticamente con cada cambio</p>
                     </div>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                     <span style={{ color: '#ea580c', fontSize: '1.25rem' }}>💾</span>
                     <div>
                       <p style={{ fontWeight: '600', color: '#ea580c', margin: 0 }}>Persistencia</p>
                       <p style={{ fontSize: '0.875rem', color: '#c2410c', margin: 0 }}>Los valores se mantienen hasta que se limpien o se inicie una nueva venta</p>
                     </div>
                   </div>
                 </div>
               </div>

               {/* 5. NOTAS IMPORTANTES */}
               <div style={{ backgroundColor: '#fef2f2', padding: '1.5rem', borderRadius: '0.5rem', border: '1px solid #fecaca' }}>
                 <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#dc2626', marginBottom: '0.75rem', marginTop: 0 }}>
                   ⚠️ Notas Importantes
                 </h3>
                 <ul style={{ color: '#991b1b', margin: 0, paddingLeft: '1rem' }}>
                   <li style={{ marginBottom: '0.5rem' }}>• Los descuentos y recargos se aplican <strong>AL TOTAL DE LA VENTA</strong></li>
                   <li style={{ marginBottom: '0.5rem' }}>• No se modifican los precios individuales de los productos</li>
                   <li style={{ marginBottom: '0.5rem' }}>• El botón "Limpiar" resetea todos los valores aplicados</li>
                   <li style={{ marginBottom: '0.5rem' }}>• Los cambios se reflejan inmediatamente en el resumen</li>
                   <li style={{ marginBottom: '0.5rem' }}>• Se pueden combinar descuentos y recargos en la misma venta</li>
                 </ul>
               </div>
             </div>

             {/* Footer del popup */}
             <div style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid #e5e7eb', textAlign: 'center' }}>
               <button
                 onClick={() => setMostrarPopupInfo(false)}
                 style={{ backgroundColor: '#2563eb', color: 'white', padding: '0.75rem 1.5rem', borderRadius: '0.5rem', fontWeight: '600', border: 'none', cursor: 'pointer' }}
               >
                 ✅ Entendido - Cerrar
               </button>
             </div>
           </div>
         </div>
       )}


       {/* POPUP COMPACTO DE VENTA COMPLETADA - Mismo estilo que gestión de items */}
       {mostrarComprobante && ventaCompletada && (
         <div style={{
           position: 'fixed',
           top: 0,
           left: 0,
           right: 0,
           bottom: 0,
           backgroundColor: 'rgba(0, 0, 0, 0.6)',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           zIndex: 99999
         }}>
           <div style={{
             backgroundColor: 'white',
             borderRadius: '0.5rem',
             padding: '1rem',
             width: '100%',
             maxWidth: '32rem',
             margin: '0 1rem',
             textAlign: 'center'
           }}>
             
             {/* Header del popup */}
             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem' }}>
               <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#111827', margin: 0 }}>
                 🎉 ¡Venta Completada!
               </h2>
               <button
                 onClick={() => {
                   setMostrarComprobante(false);
                   setVentaCompletada(null);
                 }}
                 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#9ca3af', cursor: 'pointer', border: 'none', background: 'none' }}
               >
                 ✕
               </button>
             </div>

             {/* Contenido del popup */}
             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
               
               {/* Ticket Number */}
               <div style={{ backgroundColor: '#f0f9ff', padding: '0.5rem', borderRadius: '0.375rem', border: '1px solid #0ea5e9' }}>
                 <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#0369a1' }}>
                   Ticket #{ventaCompletada.numeroTicket}
                 </span>
               </div>
               
               {/* Resumen de la Venta */}
               <div style={{ backgroundColor: '#eff6ff', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #bfdbfe' }}>
                 <h3 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem', marginTop: 0 }}>
                   📊 Resumen de la Venta
                 </h3>
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.375rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                     <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>Fecha:</span>
                     <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#111827' }}>{ventaCompletada.fechaLegible}</span>
                   </div>
                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.375rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                     <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>Items:</span>
                     <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#111827' }}>{ventaCompletada.items.length}</span>
                   </div>
                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.375rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                     <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>Subtotal:</span>
                     <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#111827' }}>${ventaCompletada.subtotal.toFixed(2)}</span>
                   </div>
                   {ventaCompletada.descuentoTotal > 0 && (
                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.375rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                       <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>Descuento:</span>
                       <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#dc2626' }}>-${ventaCompletada.descuentoTotal.toFixed(2)}</span>
                     </div>
                   )}
                   {ventaCompletada.recargoTotal > 0 && (
                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.375rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                       <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>Recargo:</span>
                       <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#16a34a' }}>+${ventaCompletada.recargoTotal.toFixed(2)}</span>
                   </div>
                   )}
                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#2563eb', borderRadius: '0.25rem', color: 'white' }}>
                     <span style={{ fontSize: '0.875rem', fontWeight: '600' }}>Total:</span>
                     <span style={{ fontSize: '1rem', fontWeight: 'bold' }}>${ventaCompletada.total.toFixed(2)}</span>
                   </div>
                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.375rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                     <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>Recibido:</span>
                     <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#111827' }}>${ventaCompletada.montoRecibido.toFixed(2)}</span>
                   </div>
                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.375rem', backgroundColor: 'white', borderRadius: '0.25rem' }}>
                     <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>Cambio:</span>
                     <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#0ea5e9' }}>${ventaCompletada.cambio.toFixed(2)}</span>
                   </div>
                 </div>
               </div>
               
               {/* Acciones Completadas */}
               <div style={{ backgroundColor: '#f0fdf4', padding: '0.75rem', borderRadius: '0.5rem', border: '1px solid #bbf7d0' }}>
                 <h3 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#166534', marginBottom: '0.5rem', marginTop: 0 }}>
                   ✅ Acciones Completadas
                 </h3>
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', fontSize: '0.75rem', color: '#065f46' }}>
                   <div style={{ display: 'flex', alignItems: 'center' }}>
                     <span style={{ marginRight: '0.5rem', color: '#059669' }}>✓</span>
                     <span>Stock actualizado en productos</span>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'center' }}>
                     <span style={{ marginRight: '0.5rem', color: '#059669' }}>✓</span>
                     <span>Venta registrada en localStorage</span>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'center' }}>
                     <span style={{ marginRight: '0.5rem', color: '#059669' }}>✓</span>
                     <span>Estadísticas actualizadas</span>
                   </div>
                   <div style={{ display: 'flex', alignItems: 'center' }}>
                     <span style={{ marginRight: '0.5rem', color: '#059669' }}>✓</span>
                     <span>Comprobante enviado a impresora</span>
                   </div>
                 </div>
               </div>
             </div>

             {/* Botones de acción */}
             <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', marginTop: '1rem', paddingTop: '0.75rem', borderTop: '1px solid #e5e7eb' }}>
               <button
                 onClick={() => {
                   setMostrarComprobante(false);
                   setVentaCompletada(null);
                 }}
                 style={{
                   padding: '0.5rem 1rem',
                   backgroundColor: '#10b981',
                   color: 'white',
                   borderRadius: '0.375rem',
                   fontWeight: '600',
                   border: 'none',
                   cursor: 'pointer',
                   fontSize: '0.875rem'
                 }}
               >
                 ✅ Continuar con Nueva Venta
               </button>
             </div>
           </div>
         </div>
       )}

      {/* Componente de popup para notificaciones */}
      <Popup 
        isOpen={toast.isOpen}
        type={toast.type}
        title={toast.title}
        message={toast.message}
        showCloseButton={toast.showCloseButton}
        autoClose={toast.autoClose}
        autoCloseDelay={toast.autoCloseDelay}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        onClose={hideToast}
      />

     </div>
   );
 };

export default Ventas;
